// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:18.302Z
// Property: Plantation Apartments (ID: 6737460151192623)
// Collections: 34 amenities, 5 floorplans (live), 69 photos, 72 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192623",
  "property_external_id": "4687860",
  "property_zillow_url": "https://www.zillow.com/apartments/mission-tx/plantation/5XmRkC/",
  "property_apartments_url": "https://www.apartments.com/the-plantation-apartments-mission-tx/7xb74mz",
  "property_google_business_url": "https://www.google.com/maps/place/The+Plantation/data=!4m2!3m1!1s0x0:0xdc9039acfab7797e?sa=X&ved=2ahUKEwjc9d6yxLySAxVHnWoFHeChCjkQ_BJ6BAhEEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17320214186",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "plantation-apartments",
  "property_name": "Plantation Apartments",
  "property_website_url": "https://www.theplantationmission.com/",
  "property_domain": "https://www.theplantationmission.com/",
  "property_address": "4405 S Shary Rd",
  "property_full_address": "4405 S Shary Rd, Mission, TX 78572",
  "property_address_1": "4405 S Shary Rd",
  "property_address_2": null,
  "property_address_city": "Mission",
  "property_address_state": "TX",
  "property_address_zip_full": "78572-0902",
  "property_address_zip": "78572",
  "property_address_country": "US",
  "property_address_county": "Hidalgo County",
  "property_neighborhood_address": "Mission",
  "property_address_latitude": "26.1574345",
  "property_address_longitude": "-98.2931055",
  "property_email": "plantation@rreafresidential.com",
  "property_phone": "(956) 583-4400",
  "property_call_tracking_phone": "956-300-2710",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your ideal living space at Plantation Apartments in Mission, TX, featuring one, two, and three-bedroom floor plans. Enjoy amenities like a refreshing pool, clubhouse, and on-site management. With flexible leasing options and stunning courtyard and pool views, find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Welcome to Plantation Apartments in Mission, TX – Your Ideal Home Awaits!**\n\nDiscover the perfect blend of comfort and convenience at Plantation Apartments, where our thoughtfully designed floor plans cater to your unique lifestyle. Choose from spacious one, two, or three-bedroom apartments that provide ample room to personalize your space. Each apartment features modern vinyl flooring and stunning views of our refreshing pool or serene courtyard.\n\nAt Plantation Apartments, we pride ourselves on our exceptional amenities designed to elevate your living experience. Enjoy the ease of on-site management and maintenance, ensuring your needs are met with unwavering attention. Dive into relaxation at our sparkling pool, or gather with friends in our inviting clubhouse. With the option for short-term leases, you’ll find flexibility that aligns with your lifestyle.\n\nOur community offers convenient access to both first and second-floor apartments, including garage options that provide added security and convenience. As a price leader in the area, we ensure you get the best value without compromising on quality or comfort.\n\nLocated in the heart of Mission, TX, Plantation Apartments is surrounded by vibrant dining, shopping, and entertainment options, so you’ll never be far from everything you love. \n\nReady to find your new home? Browse our availability or schedule a tour today to experience the exceptional lifestyle waiting for you at Plantation Apartments! Your dream apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bd49-722a-b8c9-df9664f77fa0.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
    "public_id": "019e84c6-bd49-722a-b8c9-df9664f77fa0",
    "storage_key": "property/6737460151192623/019e84c6-bd49-722a-b8c9-df9664f77fa0.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "300",
  "property_year_built": "2011",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.33333333333333",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "87",
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "60",
  "property_pet_restrictions": "Cats and dogs allowed, up to 60 lbs each. Maximum 2 pets per unit.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. 100lb weight limit per pet. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://theplantationmission.loftliving.com/login",
  "property_apply_now_url": "https://8346184.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f58b-759d-8407-e1c0a03c82d9.webp",
  "property_primary_logo_media": {
    "alt_text": "The Plantation Apartments logo with a palm tree graphic.",
    "public_id": "019e1dfd-f58b-759d-8407-e1c0a03c82d9",
    "storage_key": "property/6737460151192623/019e1dfd-f58b-759d-8407-e1c0a03c82d9.webp",
    "width": 1100,
    "height": 467
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-5b1d-7362-832d-93f864878c47.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Plantation Apartments logo",
    "public_id": "019e84c7-5b1d-7362-832d-93f864878c47",
    "storage_key": "property/6737460151192623/019e84c7-5b1d-7362-832d-93f864878c47.webp",
    "width": 1100,
    "height": 467
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e8e87-490c-75bb-924e-67faeb352403.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-490c-75bb-924e-67faeb352403",
    "storage_key": "property/6737460151192623/019e8e87-490c-75bb-924e-67faeb352403.webp",
    "width": 1100,
    "height": 467
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e8e87-3d5a-716d-acc7-6746b1941d82.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-3d5a-716d-acc7-6746b1941d82",
    "storage_key": "property/6737460151192623/019e8e87-3d5a-716d-acc7-6746b1941d82.webp",
    "width": 1100,
    "height": 467
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#283618",
  "property_secondary_color": "#83934d",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#83918f",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "611 - 1443",
  "property_sqft_min": "611",
  "property_sqft_max": "1443",
  "property_price_range": "784 - 1664",
  "property_price_min": "784",
  "property_price_max": "1664",
  "property_available_units": 32,
  "property_facebook_url": "https://www.facebook.com/people/The-Plantation-Apartments/61554752033663/",
  "property_instagram_url": "https://www.instagram.com/the_plantation_apartments/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJdVSbeGaoZYYRfnm3-qw5kNw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/plantation-apartments-mission",
  "property_tiktok_url": "https://www.tiktok.com/@theplantationapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Plantation Apartments",
  "property_home_romance_title": "Embrace Serenity in Your Heartfelt New Home Today",
  "property_home_amenities_blurb": "<p>The Plantation Apartments offers one, two, and three bedroom cable-ready <a href=\"/floor-plans/\">apartment homes for rent</a>. Experience five spacious floor plans accompanied by a washer and dryer, a breakfast bar, and a personal balcony or patio. Your apartment home comes designed with 9-foot ceilings, hardwood floors, a pantry, and walk-in closets. Schedule a tour to see more of our unique features!</p>",
  "property_home_floorplans_blurb": "<p>Come home to the best <a href=\"/floor-plans/\">affordable apartment home</a> living in Mission, TX. Conveniently right off Interstate 69, you can drive to your new life at The Plantation Apartments. Enjoy the restaurants like Yum Yums, entertain yourself at the International Museum of Art & Science, and shop until you drop at Concorde Square. See why a stroll around the beautiful grounds of our humble, modest community is sure to be the highlight of your day.</p>",
  "property_home_gallery_blurb": "Welcome to Plantation Apartments in Mission, TX, where your ideal lifestyle awaits! Choose from spacious one, two, or three-bedroom floor plans, then indulge in inviting amenities like shimmering pools, cabanas with grills, and vibrant community events. Picture yourself living here, where comfort meets convenience in a pet-friendly oasis!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Plantation Apartments in Mission, TX! Choose from spacious one, two, or three-bedroom floor plans that suit your lifestyle. Explore local favorites and nearby points of interest to enhance your living experience. See what's around our community today and make your next move!",
  "property_home_reviews_blurb": "At Plantation Apartments in Mission, TX, residents are raving about their serene living experience. With a perfect blend of comfort and style, one resident exclaimed, \"You can’t hear your neighbors, which is a HUGE plus!\" Experience outstanding management and unmatched amenities that truly make our community feel like home. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Come home to the best <a href=\"/floor-plans/\">affordable apartment home</a> living in Mission, TX. Conveniently right off Interstate 69, you can drive to your new life at The Plantation Apartments. Enjoy the restaurants like Yum Yums, entertain yourself at the International Museum of Art & Science, and shop until you drop at Concorde Square. See why a stroll around the beautiful grounds of our humble, modest community is sure to be the highlight of your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Join this distinguished covered parking community and be a part of all the excitement at the clubhouse or take advantage of the business center. Keep fit by working out in the state-of-the-art fitness center or swimming laps in the refreshing swimming pool. We are a pet-friendly <a href=\"/floor-plans/\">apartment</a> community, so bring along your furry friend. Many great outdoor amenities are offered and await to excite you at The Plantation Apartments in Mission, Texas!</p>",
  "property_applynow_blurb": "Discover your ideal living space at Plantation Apartments in Mission, TX! Choose from our spacious one, two, and three-bedroom floor plans, complete with modern amenities like a refreshing pool, clubhouse, and on-site management. Enjoy beautiful courtyard or pool views. Find your new home and lease online today!",
  "property_contactus_blurb": "Discover your perfect home at Plantation Apartments in Mission, TX! We offer spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Explore our diverse options and envision your new living space. Have questions? Contact our leasing team today! Your dream apartment awaits!",
  "property_faqs_blurb": "Discover your perfect home at Plantation Apartments in Mission, TX! With spacious one, two, and three-bedroom floor plans, you'll find the ideal fit for your lifestyle. Have questions? Browse our FAQs page to get answers about our community and living experience. Your new home awaits!",
  "property_floorplans_blurb": "<p>Apartment homes for rent come in all shapes and sizes. Browse all five floorplans for details about square footage and rent prices. Click on the <a href=\"/neighborhood/\">community map</a> to view how conveniently close you will be to the bocce ball court, swimming pool, and to pick up your mail.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at Plantation Apartments in Mission, TX! Our community offers spacious one, two, and three-bedroom floor plans, complemented by amenities like a refreshing pool, on-site management, and a clubhouse. Use our interactive community map to explore available apartments and pricing. Your ideal living space awaits!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. 100lb weight limit per pet. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Plantation Apartments in Mission, TX, we offer thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the comfort of living together. Explore all our options and build your new life today!",
  "property_residentaccess_blurb": "Discover your ideal living space at Plantation Apartments in Mission, TX! Choose from our thoughtfully designed one, two, and three-bedroom floor plans. Residents can easily access our portal to pay rent, schedule maintenance, and more. Experience convenience and comfort—log in now to unlock your community's perks!",
  "property_reviews_blurb": "At Plantation Apartments in Mission, TX, residents rave about the exceptional living experience and attentive management. With four and five-star ratings, one resident notes, “It’s not only quiet, but the upkeep of the facilities is outstanding.” Join our thriving community and see for yourself why it’s the perfect place to call home!",
  "property_created_at": "1752257252055",
  "property_scheduletour_blurb": "Discover your perfect home at Plantation Apartments in Mission, TX! Choose from a variety of spacious floor plans, including one, two, and three bedroom options. Schedule a tour today and see what our residents love about living in our vibrant community! Don’t miss out—experience the Plantation difference!",
  "property_thankyou_blurb": "Thank you for your interest in Plantation Apartments in Mission, TX! Explore our diverse floor plans, including one, two, and three-bedroom options, tailored to fit your lifestyle. A team member will reach out shortly to assist you further. Discover your perfect home at Plantation Apartments today!",
  "property_virtualtours_blurb": "<p>At The Plantation, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Plantation Apartments",
  "property_seo_title_home": "Plantation Apartments | Apartments in Mission, TX",
  "property_seo_description_home": "Discover your ideal living space at Plantation Apartments in Mission, TX. With a variety of floor plans including stylish one, two, and three-bedroom options, we cater to every lifestyle. Enjoy luxurious amenities like a refreshing pool, clubhouse, and on-site management, all while having the convenience of short-term leases and on-site maintenance. Experience the comfort of vinyl flooring and stunning courtyard or pool views. Don't wait—explore our price leader options and find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Mission, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Plantation Apartments in Mission, TX! Explore our diverse range of one, two, and three-bedroom floor plans tailored to your lifestyle. Browse our available apartment homes today and find your perfect fit in our welcoming community. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Mission, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover the exceptional lifestyle at Plantation Apartments in Mission, TX! Explore our diverse floor plans, including one, two, and three-bedroom options, and enjoy premium amenities like a refreshing pool, clubhouse, and on-site management. With convenient short-term leasing, garage access, and beautiful courtyard and pool views, our community is designed for your comfort. Don’t miss out—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Mission, TX",
  "property_seo_description_gallery": "Discover your dream home at Plantation Apartments in Mission, TX! Explore our stunning photo gallery showcasing our spacious one, two, and three-bedroom floor plans. Enjoy great amenities like a refreshing pool, clubhouse, and on-site management for your convenience. Whether you prefer a first or second-floor apartment with beautiful courtyard or pool views, Plantation Apartments offers flexible short-term leases and unbeatable prices. Picture yourself living here—schedule a tour today!",
  "property_seo_title_virtualtours": "Virtual Tours | Plantation Apartments Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Plantation Apartments in Mission, TX! Explore our spacious one, two, and three-bedroom floor plans designed for comfort and style. Take a virtual tour of our vibrant community and see why Plantation Apartments is the ideal place to live. Don't miss out—take your virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Plantation Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at Plantation Apartments in Mission, TX! Explore our diverse floor plans, featuring one, two, and three-bedroom options tailored to fit your lifestyle. Enjoy top-notch amenities like on-site management, a refreshing pool, and a welcoming clubhouse. With both first and second-floor options, short-term leases, and stunning courtyard or pool views, we have everything you need. Use our interactive community map to find available apartments, view pricing, and choose your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Mission, TX",
  "property_seo_description_neighborhood": "Discover the vibrant community surrounding Plantation Apartments in Mission, TX! Explore our range of spacious one, two, and three-bedroom floor plans, perfect for your lifestyle. See what's around our community and dive into local favorites and nearby points of interest. Your new home awaits!",
  "property_seo_title_contact": "Contact Us | Plantation Apartments",
  "property_seo_description_contact": "Discover your perfect home at Plantation Apartments in Mission, TX! Explore our spacious one, two, and three-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today to learn more about your future residence!",
  "property_seo_title_faqs": "FAQs | Apartments in Mission, TX",
  "property_seo_description_faqs": "Discover Plantation Apartments in Mission, TX, where comfort meets convenience! Explore our diverse floor plans, including one, two, and three-bedroom options, designed to fit your lifestyle. Enjoy top-notch amenities like a refreshing pool, a welcoming clubhouse, and on-site management for peace of mind. Have questions? Browse our FAQs page to find answers about our community, leasing options, and more. Your perfect apartment awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mission, TX",
  "property_seo_description_reviews": "Discover why Plantation Apartments in Mission, TX, is the perfect place to call home! Explore our variety of floor plans, including one, two, and three-bedroom options, tailored to fit your lifestyle. Enjoy top-notch amenities like a refreshing pool, on-site management, short-term lease options, and a welcoming clubhouse. With beautiful courtyard and pool views, along with the convenience of on-site maintenance and garage access, your comfort is our priority. Don’t just take our word for it—see what our residents have to say about living in our vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Mission, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Plantation Apartments in Mission, TX! Explore our diverse floor plans, featuring one, two, and three-bedroom options tailored to your needs. Enjoy exceptional amenities like a refreshing pool, on-site management, and a welcoming clubhouse. With flexible short-term leases and on-site maintenance, comfort and convenience are at your fingertips. Don't wait—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Plantation Apartments",
  "property_seo_description_residentaccess": "\"Welcome to the Plantation Apartments Resident Access portal in Mission, TX! Log in now to easily pay rent, request maintenance, and manage your apartment needs all in one convenient place. Stay connected and make the most of your living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Plantation Apartments",
  "property_seo_description_referafriend": "\"Invite your friends to experience the vibrant lifestyle at Plantation Apartments in Mission, TX! Great friends make great neighbors—refer a friend today and enjoy special rewards together. Join our welcoming community now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Plantation Apartments",
  "property_seo_description_scheduletour": "\"Discover your perfect home at Plantation Apartments in Mission, TX! Experience modern living and a vibrant community. Schedule a tour today and explore our stunning amenities and welcoming atmosphere!\"",
  "property_seo_title_privacy": "Privacy Policy | Plantation Apartments",
  "property_seo_description_privacy": "\"Discover how Plantation Apartments in Mission, TX prioritizes your privacy. Our privacy policy outlines the data we collect, how it's used, and your rights. Your peace of mind is our commitment. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Plantation Apartments",
  "property_seo_description_accessibility": "\"Explore Plantation Apartments in Mission, TX, where we prioritize accessibility and digital inclusion for all our residents. Discover our commitment to an inclusive living experience that welcomes everyone. Join our community today!\"",
  "property_seo_title_sitemap": "Sitemap | Plantation Apartments",
  "property_seo_description_sitemap": "Discover the complete layout of Plantation Apartments in Mission, TX! Navigate our sitemap to easily find all the features, amenities, and resources our vibrant community offers. Explore your new home today!",
  "property_seo_title_thankyou": "Thank You | Plantation Apartments",
  "property_seo_description_thankyou": "\"Thank you for your interest in Plantation Apartments, Mission, TX! Your information has been received, and our friendly team will connect with you shortly. Discover your new home in our vibrant community with outstanding amenities and exceptional living. Stay tuned for more details!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Mission, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293617638",
  "amenities": [
    {
      "id": "ec_94405b3cf5ccaef858434044",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Two Shimmering Swimming Pools with Outdoor Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf8d9af20e2b3d1907cfe1c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Cabana with Grilling Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76415aa67fb9893ddf2d7cf1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Social Terrace with Picnic Tables",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_520903822ae1fc3aee79b6f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Two 24‑Hour State‑of‑the‑art Fitness Centers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8657ad28c2e463fc6f02c1da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Two Bark Parks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13a3cfb3808027453cf1c324",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑Friendly Walking Paths",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_162831cfeb4691d8a16dde25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Business Center and Free WIFI",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4c5d72a08b6365556d1cbc5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Rentable Event Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fa76eab2092194d483e90cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ed0489b29e46d7f4d830318",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Reserved Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e4843e286df7bbabb18f76c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c906b62adabfab5638bdd21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Controlled Access Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24c915b8c5105d5621d31e4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8e90ac4497d7d613735bf34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37a375ed3dfb69b6940cc9dc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1db180223f823000d7118534",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eff69e4a6f4a554c37661d45",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9397727cb9f2a0d3d0d57e68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e89b80e9e1a5044d4b6336d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Hometown Heroes and Military Partnership Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15d19d44b34cebbe6d571b17",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c072add383460fb086162e3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "9‑Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_044e5b51d7f7da1558cfa516",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Private Patio and Balconies with Additional Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10961b51f917ad6f3be1b89d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26b7eb274a1d262a0902a13d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Wood‑Vinyl and Carpeted Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d29af808c57c66d204e85081",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Full‑Sized Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f294e0fdf1f231f81ef16d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d7f98440fdb5f42a0980875",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Custom‑Feel Hardwood Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c612df131d167d757c4001e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Black Appliance Package with Built‑In Microwave in Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_405176fc1e025b0a7ef26afe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "His and Her Sinks in Bathroom*",
      "amount": "false",
      "description": "In select apartment homes. Call our office for additional details.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa0b420fbb60fe216c239465",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Garden‑Style Tubs",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9ef459f96efc95584a56247",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "2” Faux Wood Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f57944b636fd79f906e6037e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling fans with light kits in all living areas & bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_421fa5e55cf9f86bb1bdb14c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed Internet Access and Cable Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0eba1cb51cbaa8b118f983d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a361e525-f82e-43d1-9135-100c11dcffd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bcf4-759e-8194-1d7aed795571.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a rock waterfall and lounge chairs.",
        "public_id": "019e84c6-bcf4-759e-8194-1d7aed795571",
        "storage_key": "property/6737460151192623/019e84c6-bcf4-759e-8194-1d7aed795571.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with a relaxing rock waterfall and ample lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a rock waterfall and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_70c38af0-0a7d-4610-96c7-cb86d303a239",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-2f75-749d-8e39-b8ea6c0a3ca6.webp",
      "image_media": {
        "alt_text": "Lobby with seating area overlooking pool and courtyard",
        "public_id": "019e84c7-2f75-749d-8e39-b8ea6c0a3ca6",
        "storage_key": "property/6737460151192623/019e84c7-2f75-749d-8e39-b8ea6c0a3ca6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in the comfortable lobby seating area, featuring plush chairs and a coffee table, with a picturesque view of the sparkling pool and lush courtyard.",
      "link": "",
      "alt_text": "Lobby with seating area overlooking pool and courtyard",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71297eea-c639-4a4d-be77-c2e9bdff82e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-91fc-76cd-9787-6e8c441e4072.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and light wood flooring.",
        "public_id": "019e84c7-91fc-76cd-9787-6e8c441e4072",
        "storage_key": "property/6737460151192623/019e84c7-91fc-76cd-9787-6e8c441e4072.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover this beautifully appointed kitchen, featuring dark wood cabinetry, stainless steel appliances, and ample counter space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and light wood flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5a3192d-0dd4-466a-b6ff-86f517b2d974",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-7907-76d9-b502-aa3f37fb351a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, bedside tables, and a ceiling fan.",
        "public_id": "019e84c7-7907-76d9-b502-aa3f37fb351a",
        "storage_key": "property/6737460151192623/019e84c7-7907-76d9-b502-aa3f37fb351a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with a dusty rose comforter, two nightstands, and a decorative wall piece.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, bedside tables, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8266eb0-cdc5-43e1-b307-4a0f1437350b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-bf2c-731b-8f89-83178601bb40.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool and water feature at apartment complex.",
        "public_id": "019e84c7-bf2c-731b-8f89-83178601bb40",
        "storage_key": "property/6737460151192623/019e84c7-bf2c-731b-8f89-83178601bb40.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax by the resort-style pool or enjoy the serene water feature. This apartment community offers the perfect oasis.",
      "link": "",
      "alt_text": "Luxury swimming pool and water feature at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a422fd31-0d95-40d2-a72d-8bf4f22b701e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bd49-722a-b8c9-df9664f77fa0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e84c6-bd49-722a-b8c9-df9664f77fa0",
        "storage_key": "property/6737460151192623/019e84c6-bd49-722a-b8c9-df9664f77fa0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, perfect for relaxing or soaking up the sun. Surrounded by lush landscaping and comfortable lounge chairs, it's the ideal spot to unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb95acb0-1671-4e84-98ca-99f5146c5924",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-b897-77bb-a380-b7594e3d7d87.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool, lounge chairs, and umbrellas.",
        "public_id": "019e84c7-b897-77bb-a380-b7594e3d7d87",
        "storage_key": "property/6737460151192623/019e84c7-b897-77bb-a380-b7594e3d7d87.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, complete with ample lounge seating and umbrellas, perfect for relaxing on sunny days. The surrounding courtyard offers beautiful landscaping and a tranquil atmosphere.",
      "link": "",
      "alt_text": "Apartment complex courtyard with a swimming pool, lounge chairs, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e744e96-2f5b-4a0b-a11a-0f58e70ef914",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-b311-715b-91de-70ca7d9925fa.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool area with lounge chairs, tables, and umbrellas.",
        "public_id": "019e84c7-b311-715b-91de-70ca7d9925fa",
        "storage_key": "property/6737460151192623/019e84c7-b311-715b-91de-70ca7d9925fa.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax by the resort-style swimming pool, featuring a rock waterfall, comfortable lounge seating, and shaded tables perfect for enjoying a sunny afternoon.",
      "link": "",
      "alt_text": "Apartment complex swimming pool area with lounge chairs, tables, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1db4c402-0a0d-48f2-8655-4af15f072a5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bfdc-719d-85f1-decda81b4484.webp",
      "image_media": {
        "alt_text": "Apartment buildings with balconies and manicured lawns.",
        "public_id": "019e84c6-bfdc-719d-85f1-decda81b4484",
        "storage_key": "property/6737460151192623/019e84c6-bfdc-719d-85f1-decda81b4484.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with balconies and lush green lawns, creating a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Apartment buildings with balconies and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a8252a6-af35-4114-a648-3745dfe08085",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-bad0-7589-ac8a-f6d96f6ecaaa.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with a stone water feature and lounge chairs.",
        "public_id": "019e84c7-bad0-7589-ac8a-f6d96f6ecaaa",
        "storage_key": "property/6737460151192623/019e84c7-bad0-7589-ac8a-f6d96f6ecaaa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with a unique stone water feature and plenty of lounge chairs for relaxation. Perfect for unwinding on a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with a stone water feature and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_28cce07c-d291-4fed-af52-f83666a69bf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-6c6d-744e-be75-74e51297a332.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets and granite countertops.",
        "public_id": "019e84c7-6c6d-744e-be75-74e51297a332",
        "storage_key": "property/6737460151192623/019e84c7-6c6d-744e-be75-74e51297a332.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, a double sink, and a breakfast bar overlooking the living area.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b40f026-1ad9-4643-87cd-b0b46473c4e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-6d0e-7199-9856-b46a5bbb9d4e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and a breakfast bar.",
        "public_id": "019e84c7-6d0e-7199-9856-b46a5bbb9d4e",
        "storage_key": "property/6737460151192623/019e84c7-6d0e-7199-9856-b46a5bbb9d4e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark cherry wood cabinets, a black side-by-side refrigerator with ice maker, microwave, and a tiled backsplash, perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6debef58-4074-4199-94b5-a08f74b77f40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-b5f8-7752-a2ba-4a5906423584.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e84c7-b5f8-7752-a2ba-4a5906423584",
        "storage_key": "property/6737460151192623/019e84c7-b5f8-7752-a2ba-4a5906423584.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge areas.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1b4f4c8-0f88-41ef-a10e-b5cbfabfcc9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-8c04-769c-a832-479c09a7d565.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a large mirror.",
        "public_id": "019e84c7-8c04-769c-a832-479c09a7d565",
        "storage_key": "property/6737460151192623/019e84c7-8c04-769c-a832-479c09a7d565.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a clean white bathtub and toilet, complemented by a dark wood vanity and a large, ornate mirror.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b07af7a1-4d58-4a57-aff5-54aee9e963f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-aef9-73ba-9122-6d787b789c4c.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with thatched roof, picnic tables, and grills with apartment buildings in the background.",
        "public_id": "019e84c7-aef9-73ba-9122-6d787b789c4c",
        "storage_key": "property/6737460151192623/019e84c7-aef9-73ba-9122-6d787b789c4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community picnic area, featuring BBQ grills and covered seating. Perfect for al fresco dining and relaxing in the fresh air.",
      "link": "",
      "alt_text": "Outdoor picnic area with thatched roof, picnic tables, and grills with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a217e05-a38e-43f4-9639-bc2f4ba397fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-9147-77ee-be42-89d5b1e1efbd.webp",
      "image_media": {
        "alt_text": "Living room with a coffee table, dining area, and kitchen visible.",
        "public_id": "019e84c7-9147-77ee-be42-89d5b1e1efbd",
        "storage_key": "property/6737460151192623/019e84c7-9147-77ee-be42-89d5b1e1efbd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a coffee table, dining space, and an open-concept kitchen.",
      "link": "",
      "alt_text": "Living room with a coffee table, dining area, and kitchen visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2164ec38-0ff4-4431-9804-f25e23fc7333",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-af8f-74bb-b8cd-128deb77d2f2.webp",
      "image_media": {
        "alt_text": "Lounge area with seating, coffee table, and TV, overlooking the community pool area.",
        "public_id": "019e84c7-af8f-74bb-b8cd-128deb77d2f2",
        "storage_key": "property/6737460151192623/019e84c7-af8f-74bb-b8cd-128deb77d2f2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in our stylish lounge, complete with comfortable seating and entertainment, offering a view of the resort-style pool and outdoor amenities.",
      "link": "",
      "alt_text": "Lounge area with seating, coffee table, and TV, overlooking the community pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_43a6261c-e788-4268-ab5b-328d0894af3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-a27c-734f-8a39-7bfe6c953da1.webp",
      "image_media": {
        "alt_text": "A serene water feature with rocks and a fountain in the foreground, with a swimming pool and apartment buildings in the background.",
        "public_id": "019e84c7-a27c-734f-8a39-7bfe6c953da1",
        "storage_key": "property/6737460151192623/019e84c7-a27c-734f-8a39-7bfe6c953da1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the relaxing ambiance of our community's water feature, complete with a soothing fountain and natural rock landscaping, adjacent to our sparkling swimming pool and apartment homes.",
      "link": "",
      "alt_text": "A serene water feature with rocks and a fountain in the foreground, with a swimming pool and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3850f949-b3a8-418a-abc2-58e1e9713edb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-97b0-70a8-a0be-dd49c2c2fcbc.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and decorative mirror.",
        "public_id": "019e84c7-97b0-70a8-a0be-dd49c2c2fcbc",
        "storage_key": "property/6737460151192623/019e84c7-97b0-70a8-a0be-dd49c2c2fcbc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sofa with red and patterned pillows, an armchair, and a stylish coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and decorative mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec74313f-e437-4487-ae5c-16cc97a6bd8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-d78d-74bb-82d7-35801f1810a3.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and surrounding residential areas.",
        "public_id": "019e84c7-d78d-74bb-82d7-35801f1810a3",
        "storage_key": "property/6737460151192623/019e84c7-d78d-74bb-82d7-35801f1810a3.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial view showcasing the apartment complex with its buildings, parking lots, and an inviting outdoor swimming pool, set against a backdrop of suburban homes and distant fields.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a pool and surrounding residential areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da382f89-b1df-4266-a9d2-caf062ef2612",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-986a-7061-ae23-d09b89e82126.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a stone waterfall feature and lounge chairs.",
        "public_id": "019e84c7-986a-7061-ae23-d09b89e82126",
        "storage_key": "property/6737460151192623/019e84c7-986a-7061-ae23-d09b89e82126.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with a unique stone waterfall and ample lounge seating for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a stone waterfall feature and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c444be99-79a0-4d18-bc3e-8c7f04c4aff6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-d208-74c5-ac2d-a45acfa9fbea.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and courtyard.",
        "public_id": "019e84c7-d208-74c5-ac2d-a45acfa9fbea",
        "storage_key": "property/6737460151192623/019e84c7-d208-74c5-ac2d-a45acfa9fbea.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Spacious apartment complex with a resort-style pool and lush landscaping, offering a comfortable and vibrant living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a pool and courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_062fd586-c3f7-4d4c-86c0-a7cfa40223c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-9893-73d0-bb47-f05b18fd1a38.webp",
      "image_media": {
        "alt_text": "Outdoor water feature with rocks and a small bridge, with apartment buildings in the background.",
        "public_id": "019e84c7-9893-73d0-bb47-f05b18fd1a38",
        "storage_key": "property/6737460151192623/019e84c7-9893-73d0-bb47-f05b18fd1a38.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene outdoor water feature with a charming bridge, set against the backdrop of our beautiful apartment buildings and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor water feature with rocks and a small bridge, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e2f7e211-e049-4acb-897f-f9fcaebd7da1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-8cec-761d-8496-b453dbe20f8f.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with dark wood cabinets, stainless steel sink, black dishwasher and refrigerator, and a round dining table with chairs.",
        "public_id": "019e84c7-8cec-761d-8496-b453dbe20f8f",
        "storage_key": "property/6737460151192623/019e84c7-8cec-761d-8496-b453dbe20f8f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring dark wood cabinetry, a double stainless steel sink, and a dishwasher, seamlessly flowing into a charming dining area with a round table and chairs.",
      "link": "",
      "alt_text": "Kitchen and dining area with dark wood cabinets, stainless steel sink, black dishwasher and refrigerator, and a round dining table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d916454-2c4f-4dd7-8638-4ad182dc36c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-789c-70ed-a2a1-3e5ac6ab3472.webp",
      "image_media": {
        "alt_text": "Bedroom with king size bed and blue floral comforter, nightstand, dresser, and walk-in closet.",
        "public_id": "019e84c7-789c-70ed-a2a1-3e5ac6ab3472",
        "storage_key": "property/6737460151192623/019e84c7-789c-70ed-a2a1-3e5ac6ab3472.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with a blue floral comforter, a stylish headboard, and convenient access to a walk-in closet and en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with king size bed and blue floral comforter, nightstand, dresser, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1e4c3fe-519c-4a6b-aee3-116e09b817cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-7320-73ff-b057-bdca38acd34c.webp",
      "image_media": {
        "alt_text": "Living room with view of kitchen and doorway to another room.",
        "public_id": "019e84c7-7320-73ff-b057-bdca38acd34c",
        "storage_key": "property/6737460151192623/019e84c7-7320-73ff-b057-bdca38acd34c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting, leading into a modern kitchen with dark wood cabinetry and stainless steel appliances.",
      "link": "",
      "alt_text": "Living room with view of kitchen and doorway to another room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e99a7d8d-0957-4a0b-af1b-a01fea748813",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-d81a-77a1-a1fd-031fefa41a46.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines and dumbbells",
        "public_id": "019e84c6-d81a-77a1-a1fd-031fefa41a46",
        "storage_key": "property/6737460151192623/019e84c6-d81a-77a1-a1fd-031fefa41a46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Equipped fitness center featuring weight machines and a full set of dumbbells for residents to use.",
      "link": "",
      "alt_text": "Fitness center with weight machines and dumbbells",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a213692-4416-4758-b7ec-579351dc9b4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-69b4-740f-b5f5-4e25ef818df3.webp",
      "image_media": {
        "alt_text": "View of a bedroom with carpet and a ceiling fan, looking into a bathroom and a closet.",
        "public_id": "019e84c7-69b4-740f-b5f5-4e25ef818df3",
        "storage_key": "property/6737460151192623/019e84c7-69b4-740f-b5f5-4e25ef818df3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan, and convenient access to a private bathroom and a walk-in closet.",
      "link": "",
      "alt_text": "View of a bedroom with carpet and a ceiling fan, looking into a bathroom and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_197b52aa-d4a9-434e-8bdc-d7ec62010a5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-69b3-7453-ad82-12981d275cfc.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a rock waterfall feature and lounge chairs.",
        "public_id": "019e84c7-69b3-7453-ad82-12981d275cfc",
        "storage_key": "property/6737460151192623/019e84c7-69b3-7453-ad82-12981d275cfc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with a relaxing rock waterfall and ample lounge seating for sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a rock waterfall feature and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c87f8dd-9c47-40d6-9c04-c094e4576ea3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-7037-753a-87d1-6adfe46319f4.webp",
      "image_media": {
        "alt_text": "View of apartment buildings from a covered patio with lush greenery and a blue sky.",
        "public_id": "019e84c7-7037-753a-87d1-6adfe46319f4",
        "storage_key": "property/6737460151192623/019e84c7-7037-753a-87d1-6adfe46319f4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living on your private patio or balcony with scenic views of the community grounds and lush landscaping.",
      "link": "",
      "alt_text": "View of apartment buildings from a covered patio with lush greenery and a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80991939-2cdc-4745-87f9-22dc083c53ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-65d9-72da-bd42-13ee76eb2297.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and in-unit washer and dryer.",
        "public_id": "019e84c7-65d9-72da-bd42-13ee76eb2297",
        "storage_key": "property/6737460151192623/019e84c7-65d9-72da-bd42-13ee76eb2297.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious bathroom featuring a vanity, toilet, and a convenient in-unit washer and dryer.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and in-unit washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f27cc441-9b03-40cf-9712-c7eede2e28bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-5690-720c-89d5-ef077711b063.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a decorative water feature and walkway.",
        "public_id": "019e84c7-5690-720c-89d5-ef077711b063",
        "storage_key": "property/6737460151192623/019e84c7-5690-720c-89d5-ef077711b063.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds featuring a decorative water stream and a paved walkway leading to the apartment buildings.",
      "link": "",
      "alt_text": "Apartment building exterior with a decorative water feature and walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9862290c-cde5-4386-8594-f59a5f683cca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-592c-71fe-9f2b-119227c6f61b.webp",
      "image_media": {
        "alt_text": "Living and dining area with a large window, accent chair, dresser, and dining table.",
        "public_id": "019e84c7-592c-71fe-9f2b-119227c6f61b",
        "storage_key": "property/6737460151192623/019e84c7-592c-71fe-9f2b-119227c6f61b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this well-appointed apartment, featuring a combined living and dining space. Enjoy natural light from the large window and a charming dining set.",
      "link": "",
      "alt_text": "Living and dining area with a large window, accent chair, dresser, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f010bad-6662-4112-bbb2-59e28e96e6a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-34a8-74ae-b19e-b989ac60c7e5.webp",
      "image_media": {
        "alt_text": "Kitchen with cherry wood cabinets, black appliances, and double doors.",
        "public_id": "019e84c7-34a8-74ae-b19e-b989ac60c7e5",
        "storage_key": "property/6737460151192623/019e84c7-34a8-74ae-b19e-b989ac60c7e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring cherry wood cabinetry, black appliances, and a double-door pantry. Perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with cherry wood cabinets, black appliances, and double doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f7c0ca27-db2c-4b9f-a677-d5bc2f8c1995",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-4b46-71ec-8f1e-e3b1911a9bef.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green lawns and walkways.",
        "public_id": "019e84c7-4b46-71ec-8f1e-e3b1911a9bef",
        "storage_key": "property/6737460151192623/019e84c7-4b46-71ec-8f1e-e3b1911a9bef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds and exteriors of apartment buildings, featuring well-maintained lawns and convenient walkways.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with green lawns and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52266df8-dcc6-4f3b-8515-1c85babb5613",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-472b-77cf-aa84-a916cf8c8427.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and a laundry hamper.",
        "public_id": "019e84c7-472b-77cf-aa84-a916cf8c8427",
        "storage_key": "property/6737460151192623/019e84c7-472b-77cf-aa84-a916cf8c8427.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample wire shelving for storage and a decorative laundry hamper.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and a laundry hamper.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29cacdbd-52e9-4dd5-94d6-f36f1039c827",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-405f-77fa-a0b4-07121c4b742b.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with a thatched roof pavilion, picnic table, grill, and trash can, with apartment buildings in the background.",
        "public_id": "019e84c7-405f-77fa-a0b4-07121c4b742b",
        "storage_key": "property/6737460151192623/019e84c7-405f-77fa-a0b4-07121c4b742b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at the picnic area, complete with a grill and shaded seating, set against the backdrop of our apartment community.",
      "link": "",
      "alt_text": "Outdoor picnic area with a thatched roof pavilion, picnic table, grill, and trash can, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_44fcb935-ebf4-49ed-90a5-f8e89487859d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-3de6-77d9-9f48-ca1f8a618671.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stone and beige siding, surrounded by green grass and trees.",
        "public_id": "019e84c7-3de6-77d9-9f48-ca1f8a618671",
        "storage_key": "property/6737460151192623/019e84c7-3de6-77d9-9f48-ca1f8a618671.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment complex showing the building's facade with stone and beige siding, a well-maintained lawn, and trees.",
      "link": "",
      "alt_text": "Exterior view of apartment building with stone and beige siding, surrounded by green grass and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_829210af-48ec-4b6f-8c10-c0fa1202155a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-3903-72d8-9428-a3ba3dacd529.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green lawns.",
        "public_id": "019e84c7-3903-72d8-9428-a3ba3dacd529",
        "storage_key": "property/6737460151192623/019e84c7-3903-72d8-9428-a3ba3dacd529.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring private balconies, lush green lawns, and inviting walkways, creating a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and green lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ae6c7ad-d3de-4308-9fab-b4ee516f2662",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-3a30-749b-8177-0a3e10ff1446.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and manicured grounds.",
        "public_id": "019e84c7-3a30-749b-8177-0a3e10ff1446",
        "storage_key": "property/6737460151192623/019e84c7-3a30-749b-8177-0a3e10ff1446.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Expansive exterior view of the apartment building, showcasing its architecture, private balconies, and well-maintained green spaces.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and manicured grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01cebd86-df4b-4110-84c8-41324081cd7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-afb9-774e-ab82-caca7f0f9c38.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with covered parking and manicured landscaping.",
        "public_id": "019e84c7-afb9-774e-ab82-caca7f0f9c38",
        "storage_key": "property/6737460151192623/019e84c7-afb9-774e-ab82-caca7f0f9c38.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Exterior view of the apartment building showcasing its architecture, covered parking areas, and lush green surroundings.",
      "link": "",
      "alt_text": "Apartment building exterior with covered parking and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f092e0bd-18a7-4036-a989-a0c2ec433df5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-2e1d-72e9-abf0-a153c004d04f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "019e84c7-2e1d-72e9-abf0-a153c004d04f",
        "storage_key": "property/6737460151192623/019e84c7-2e1d-72e9-abf0-a153c004d04f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a spacious vanity with a sink, a toilet, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02f0b6ad-e3ba-4b71-a0a6-2b073c1d6f42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-183b-769d-b193-a40603aa675f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns, picnic tables, and flowering trees.",
        "public_id": "019e84c7-183b-769d-b193-a40603aa675f",
        "storage_key": "property/6737460151192623/019e84c7-183b-769d-b193-a40603aa675f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped grounds of our apartment community, complete with picnic areas perfect for outdoor relaxation.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with lush green lawns, picnic tables, and flowering trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d98c67e0-a18e-43d8-afc3-c0ca73ad2324",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-26b4-70b8-8e62-c70f3ed09c94.webp",
      "image_media": {
        "alt_text": "Business center with computers and popcorn machine.",
        "public_id": "019e84c7-26b4-70b8-8e62-c70f3ed09c94",
        "storage_key": "property/6737460151192623/019e84c7-26b4-70b8-8e62-c70f3ed09c94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the convenience of our resident business center, complete with computers and a fun popcorn machine for a quick snack.",
      "link": "",
      "alt_text": "Business center with computers and popcorn machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9fcf80ee-3a3c-44ab-8708-4ffbb16081df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-2381-73bc-bb60-d8f2d0ad4991.webp",
      "image_media": {
        "alt_text": "Outdoor decorative water feature with rocks and a small bridge in front of apartment buildings.",
        "public_id": "019e84c7-2381-73bc-bb60-d8f2d0ad4991",
        "storage_key": "property/6737460151192623/019e84c7-2381-73bc-bb60-d8f2d0ad4991.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautiful landscaping and serene water feature, a perfect spot for relaxation and enjoying the outdoors at our community.",
      "link": "",
      "alt_text": "Outdoor decorative water feature with rocks and a small bridge in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_70a8ad87-116f-455b-9a6c-17780e33ce91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-1b46-710a-9d88-3a6dc06ac9ab.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and walkways, surrounded by green grass and trees.",
        "public_id": "019e84c7-1b46-710a-9d88-3a6dc06ac9ab",
        "storage_key": "property/6737460151192623/019e84c7-1b46-710a-9d88-3a6dc06ac9ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience comfortable living in our apartment community, featuring well-maintained exteriors and beautiful green spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and walkways, surrounded by green grass and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c01a8b0-fdd5-4f77-8c97-aaf0ccf3b7d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-cb75-757a-8630-9c54398fc94f.webp",
      "image_media": {
        "alt_text": "The Plantation apartment complex sign",
        "public_id": "019e84c7-cb75-757a-8630-9c54398fc94f",
        "storage_key": "property/6737460151192623/019e84c7-cb75-757a-8630-9c54398fc94f.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Welcome to The Plantation apartment complex, featuring beautiful landscaping and well-maintained buildings.",
      "link": "",
      "alt_text": "The Plantation apartment complex sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_597ad4a8-430f-4fb8-af13-4b86ba59db1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-16de-7506-b48d-781629b0c02d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees in front of apartment buildings.",
        "public_id": "019e84c7-16de-7506-b48d-781629b0c02d",
        "storage_key": "property/6737460151192623/019e84c7-16de-7506-b48d-781629b0c02d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge areas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f70e9da4-07dd-4b7c-b32c-9b8e38b319cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-0a13-765f-9e36-25c36cc9808b.webp",
      "image_media": {
        "alt_text": "Apartment buildings with manicured lawns and walkways under a blue sky with clouds.",
        "public_id": "019e84c7-0a13-765f-9e36-25c36cc9808b",
        "storage_key": "property/6737460151192623/019e84c7-0a13-765f-9e36-25c36cc9808b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience comfortable living in these apartment buildings, surrounded by lush green lawns and well-maintained walkways. Enjoy the serene community atmosphere.",
      "link": "",
      "alt_text": "Apartment buildings with manicured lawns and walkways under a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_babced58-6ecd-4188-a2fb-bccf9916d515",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-ffdf-7789-bad2-376637d03e5f.webp",
      "image_media": {
        "alt_text": "The Plantation apartment complex monument sign with address 4405.",
        "public_id": "019e84c6-ffdf-7789-bad2-376637d03e5f",
        "storage_key": "property/6737460151192623/019e84c6-ffdf-7789-bad2-376637d03e5f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Plantation, featuring this monument sign with the property address 4405. This entrance is surrounded by lush greenery and tropical palm trees.",
      "link": "",
      "alt_text": "The Plantation apartment complex monument sign with address 4405.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc25aa0d-4c9e-491b-aff2-a0589528c7b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c7-024c-705c-a7da-5382f207f641.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight machines.",
        "public_id": "019e84c7-024c-705c-a7da-5382f207f641",
        "storage_key": "property/6737460151192623/019e84c7-024c-705c-a7da-5382f207f641.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af542acc-9d21-47b5-801e-35a913094bcf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-fbab-751b-94ee-e193f0de899b.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with multiple entrances and balconies.",
        "public_id": "019e84c6-fbab-751b-94ee-e193f0de899b",
        "storage_key": "property/6737460151192623/019e84c6-fbab-751b-94ee-e193f0de899b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing its multiple entrances, balconies, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Apartment building exterior with multiple entrances and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a530a8f0-d96c-4c0f-81e8-c71fb5923b57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-ff46-724d-a14e-0d5759a541a5.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving",
        "public_id": "019e84c6-ff46-724d-a14e-0d5759a541a5",
        "storage_key": "property/6737460151192623/019e84c6-ff46-724d-a14e-0d5759a541a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample white wire shelving for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with white wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d71d626-4717-43b1-9390-3c8bc83f2166",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-f52e-747d-8cca-97b74ecccb05.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
        "public_id": "019e84c6-f52e-747d-8cca-97b74ecccb05",
        "storage_key": "property/6737460151192623/019e84c6-f52e-747d-8cca-97b74ecccb05.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, featuring comfortable lounge chairs and convenient seating areas for enjoying the sunshine.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_988e5246-3a7e-44ba-9fc8-444ea6027c33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-e91b-7008-a314-a0d1b36d050c.webp",
      "image_media": {
        "alt_text": "Four attached garage doors with beige panels and green siding underneath apartments.",
        "public_id": "019e84c6-e91b-7008-a314-a0d1b36d050c",
        "storage_key": "property/6737460151192623/019e84c6-e91b-7008-a314-a0d1b36d050c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Four attached garage doors with beige panels and light green siding are visible. The garages are located below apartment units.",
      "link": "",
      "alt_text": "Four attached garage doors with beige panels and green siding underneath apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7050c808-cf3a-48e5-938f-7cc2ab50d9ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-e3b5-712d-99a7-6adfa2b627d9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and a well-maintained lawn.",
        "public_id": "019e84c6-e3b5-712d-99a7-6adfa2b627d9",
        "storage_key": "property/6737460151192623/019e84c6-e3b5-712d-99a7-6adfa2b627d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring private balconies and lush green spaces, perfect for a relaxing atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and a well-maintained lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c7ddd05-0364-4c29-8959-1b48728b2bb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-dc3c-7586-bc44-74cd62adc4e1.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer units with a water heater above.",
        "public_id": "019e84c6-dc3c-7586-bc44-74cd62adc4e1",
        "storage_key": "property/6737460151192623/019e84c6-dc3c-7586-bc44-74cd62adc4e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stackable washer and dryer units are provided for your convenience, along with a water heater for hot water.",
      "link": "",
      "alt_text": "Stackable washer and dryer units with a water heater above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79ab040a-b331-4d30-b4f4-5d99243cfd47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-e37a-70d0-b264-062aeeedd653.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lazy river with stone archway and lounge chairs.",
        "public_id": "019e84c6-e37a-70d0-b264-062aeeedd653",
        "storage_key": "property/6737460151192623/019e84c6-e37a-70d0-b264-062aeeedd653.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with a lazy river and ample lounge seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lazy river with stone archway and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_815b8744-b1f3-4354-a23d-c76285e340e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-d709-75b9-90d2-d9e8192b588d.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e84c6-d709-75b9-90d2-d9e8192b588d",
        "storage_key": "property/6737460151192623/019e84c6-d709-75b9-90d2-d9e8192b588d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the resort-style swimming pool, surrounded by lush landscaping and modern apartment buildings.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_505a8114-82c7-474e-9f5e-1643dac0dabb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-e091-742c-a14f-df4cc0f3f5ac.webp",
      "image_media": {
        "alt_text": "Green picnic table and grill in front of apartment buildings",
        "public_id": "019e84c6-e091-742c-a14f-df4cc0f3f5ac",
        "storage_key": "property/6737460151192623/019e84c6-e091-742c-a14f-df4cc0f3f5ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling at the community picnic area. Perfect for social gatherings and relaxing outdoors.",
      "link": "",
      "alt_text": "Green picnic table and grill in front of apartment buildings",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fd45815-5362-4888-ad44-c47a458d2fcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-e2d7-718b-a8a7-424b71766fa9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables, surrounded by apartment buildings and trees.",
        "public_id": "019e84c6-e2d7-718b-a8a7-424b71766fa9",
        "storage_key": "property/6737460151192623/019e84c6-e2d7-718b-a8a7-424b71766fa9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and tables for your convenience. A perfect amenity for our residents.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables, surrounded by apartment buildings and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_308a5a2e-fb96-4f20-b967-a117db309e0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-dac6-7580-871e-0d3b20996cb4.webp",
      "image_media": {
        "alt_text": "Covered patio with seating overlooking apartment buildings and a pool area.",
        "public_id": "019e84c6-dac6-7580-871e-0d3b20996cb4",
        "storage_key": "property/6737460151192623/019e84c6-dac6-7580-871e-0d3b20996cb4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax on the shaded patio with comfortable seating, overlooking the sparkling pool and lush landscaping. A perfect spot to unwind or socialize.",
      "link": "",
      "alt_text": "Covered patio with seating overlooking apartment buildings and a pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_07d5e114-f2b1-47c1-b062-fe5218e82a33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bfc3-7519-a22b-1461b2e4e213.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and landscaping.",
        "public_id": "019e84c6-bfc3-7519-a22b-1461b2e4e213",
        "storage_key": "property/6737460151192623/019e84c6-bfc3-7519-a22b-1461b2e4e213.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor pool, complete with comfortable lounge chairs and lush landscaping, perfect for a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_772b88f0-bbf3-4b13-b8ea-2251dd2321c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bfc3-7519-a22b-18fdbff15e5d.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with a rock waterfall.",
        "public_id": "019e84c6-bfc3-7519-a22b-18fdbff15e5d",
        "storage_key": "property/6737460151192623/019e84c6-bfc3-7519-a22b-18fdbff15e5d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with a beautiful rock waterfall feature. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with a rock waterfall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_baea6763-1a19-45a9-9007-5aba2a7f7f6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-be2a-7239-acce-1dbb452dd7ff.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with waterfall feature and lounge chairs in front of apartment buildings.",
        "public_id": "019e84c6-be2a-7239-acce-1dbb452dd7ff",
        "storage_key": "property/6737460151192623/019e84c6-be2a-7239-acce-1dbb452dd7ff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with a relaxing waterfall. Lounge chairs and tables are available for your convenience.",
      "link": "",
      "alt_text": "Resort-style swimming pool with waterfall feature and lounge chairs in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_97514087-344a-4c32-9f42-0c9f5281b88c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bdda-771a-b4ae-708c0acdd28e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a rock waterfall and lounge chairs.",
        "public_id": "019e84c6-bdda-771a-b4ae-708c0acdd28e",
        "storage_key": "property/6737460151192623/019e84c6-bdda-771a-b4ae-708c0acdd28e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with a cascading rock waterfall and comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with a rock waterfall and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_38ca2842-8bea-4b78-8ff1-016205cac227",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bd79-728e-9af6-495804b87d88.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e84c6-bd79-728e-9af6-495804b87d88",
        "storage_key": "property/6737460151192623/019e84c6-bd79-728e-9af6-495804b87d88.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our beautiful resort-style swimming pool, complete with comfortable lounge chairs and lush palm trees for a relaxing oasis.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_db24fc13-8229-482a-8ab6-001d53a28a7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bd79-74ff-8af4-1f5dc8a808d7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and tables.",
        "public_id": "019e84c6-bd79-74ff-8af4-1f5dc8a808d7",
        "storage_key": "property/6737460151192623/019e84c6-bd79-74ff-8af4-1f5dc8a808d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our beautiful outdoor swimming pool, complete with comfortable lounge chairs and tables for your enjoyment.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13da4892-25d0-4a7c-92ca-7d95f97d3b5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e84c6-bd12-7321-9bb8-a63cdda33b7d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a swim-up tanning ledge, surrounded by lounge chairs and apartment buildings.",
        "public_id": "019e84c6-bd12-7321-9bb8-a63cdda33b7d",
        "storage_key": "property/6737460151192623/019e84c6-bd12-7321-9bb8-a63cdda33b7d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with a relaxing swim-up tanning ledge and ample lounge seating. Perfect for soaking up the sun and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with a swim-up tanning ledge, surrounded by lounge chairs and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fa1085a8-ae51-4d13-9c16-3fb254a12fa4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "El Itacate SHARY",
      "poi_type": "Restaurants",
      "poi_address": "301 N Shary Rd Suite 240, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-64b5-750b-9a82-0d7847c724f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-64b5-750b-9a82-0d7847c724f8",
        "storage_key": "property/6737460151192623/019e1dff-64b5-750b-9a82-0d7847c724f8.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.elitacate.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11181640130538629438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-itacate-shary",
      "poi_latitude": "26.2022959",
      "poi_longitude": "-98.2875653",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-424-6726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdVH-SunZYYRPukBs3QqLZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_03624e5e-9adc-459a-a67b-3bf3917da77c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Pokeworks",
      "poi_type": "Restaurants",
      "poi_address": "301 N Shary Rd Ste 270, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-5bb3-7578-b42a-336b8e97696c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-5bb3-7578-b42a-336b8e97696c",
        "storage_key": "property/6737460151192623/019e1dff-5bb3-7578-b42a-336b8e97696c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pokeworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=68506384945509840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pokeworks",
      "poi_latitude": "26.2022959",
      "poi_longitude": "-98.2875653",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-271-4646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw9GqtE2nZYYR0PWFszFi8wA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_1c14c3d5-d549-460b-b039-c4b95b9044aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "314 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-5f3a-70dc-b4be-fc2e8246b6ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-5f3a-70dc-b4be-fc2e8246b6ea",
        "storage_key": "property/6737460151192623/019e1dff-5f3a-70dc-b4be-fc2e8246b6ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/tx/mission/breakfast-314-n.-shary-rd-3227?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=3227&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=8564882326417409440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "26.2039509",
      "poi_longitude": "-98.2864774",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-581-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRf3ZZWnZYYRoIUh4RiT3HY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_47b9701b-e55a-4f98-99fa-ca0a573b4497",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "PINEAPPLE COFFEE SHOP",
      "poi_type": "Restaurants",
      "poi_address": "308 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "Minimalist cafe offering hot and iced teas and coffees, plus cookies and a meeting room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-5c14-705c-a47d-4f6fd703a383.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-5c14-705c-a47d-4f6fd703a383",
        "storage_key": "property/6737460151192623/019e1dff-5c14-705c-a47d-4f6fd703a383.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7558012441714365504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pineapple-coffee-shop",
      "poi_latitude": "26.2034978",
      "poi_longitude": "-98.2863919",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-591-0535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a636-727a-8752-32da9b12ae01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a636-727a-8752-32da9b12ae01",
        "storage_key": "property/6737460151192623/019e1dff-a636-727a-8752-32da9b12ae01.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJJ7tjUJWnZYYRQBRejEV042g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_d502ce84-d1be-49ca-82ac-fe71b5aa0e71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "La Concheria Cafe Shary",
      "poi_type": "Restaurants",
      "poi_address": "608 N Shary Rd Suite 13, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-62af-763b-a6c2-b3dacc7e77a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-62af-763b-a6c2-b3dacc7e77a3",
        "storage_key": "property/6737460151192623/019e1dff-62af-763b-a6c2-b3dacc7e77a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/share/19a9scP8XR/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1453354756700470919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-concheria-cafe-shary",
      "poi_latitude": "26.2074328",
      "poi_longitude": "-98.2858412",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 956-340-8909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0bg-Mn-nZYYRh37BdXNaKxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_c147d834-ca84-43d9-b405-ec4816dee2cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Cafe Arte",
      "poi_type": "Restaurants",
      "poi_address": "2224 E U.S. Business 83, Mission, TX 78572, USA",
      "poi_short_description": "Sweet cafe featuring crepes and lattes (including lavender matcha), plus board games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-5ebf-76ef-b1a7-2ec5cc88f77f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-5ebf-76ef-b1a7-2ec5cc88f77f",
        "storage_key": "property/6737460151192623/019e1dff-5ebf-76ef-b1a7-2ec5cc88f77f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cafearte.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12330944252666233645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-arte",
      "poi_latitude": "26.2103832",
      "poi_longitude": "-98.2882021",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 956-933-2345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a636-727a-8752-32da9b12ae01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a636-727a-8752-32da9b12ae01",
        "storage_key": "property/6737460151192623/019e1dff-a636-727a-8752-32da9b12ae01.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJbbstn6enZYYRLcNQNXdQIKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_2559b8df-5ab1-4716-a5fd-59ab6963c806",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Denny's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "116 S Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_long_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-5b10-716d-b4ad-e29e072e91e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-5b10-716d-b4ad-e29e072e91e6",
        "storage_key": "property/6737460151192623/019e1dff-5b10-716d-b4ad-e29e072e91e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dennys.com/TX/MISSION/202375?utm_source=G&utm_medium=organic&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=2820788282075873714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dennys-restaurant",
      "poi_latitude": "26.2006022",
      "poi_longitude": "-98.2881251",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-584-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ybQ6eynZYYRsoG3U_9zJSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5f079d94-f489-42bf-b17a-a5ff35286aa4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "209 N Shary Rd Suite 100, Mission, TX 78572, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-5a18-76e9-840c-ec067c69a787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-5a18-76e9-840c-ec067c69a787",
        "storage_key": "property/6737460151192623/019e1dff-5a18-76e9-840c-ec067c69a787.webp",
        "width": 1080,
        "height": 671
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/tx/mission/209-n.-shary-road/364786?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=364786&y_source=1_MTA4NjkwODU4OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6539902627111812493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "26.2022411",
      "poi_longitude": "-98.2875618",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-420-0544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a636-727a-8752-32da9b12ae01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a636-727a-8752-32da9b12ae01",
        "storage_key": "property/6737460151192623/019e1dff-a636-727a-8752-32da9b12ae01.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ41LlJQCnZYYRjb2kGspmwlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_9553a444-3fc7-40d9-9ac7-06dfaaf5364a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Dairy Queen",
      "poi_type": "Restaurants",
      "poi_address": "400 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "Soft-serve ice cream & signature shakes top the menu at this classic burger & fries fast-food chain.",
      "poi_long_description": "Soft-serve ice cream & signature shakes top the menu at this classic burger & fries fast-food chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-5ab3-72cd-989d-0dab512b66cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-5ab3-72cd-989d-0dab512b66cb",
        "storage_key": "property/6737460151192623/019e1dff-5ab3-72cd-989d-0dab512b66cb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dairyqueen.com/en-us/locations/tx/mission/400-n-shary-rd/42743/?y_source=1_MjkzMzkxNjMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=729980574065275298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dairy-queen",
      "poi_latitude": "26.204454",
      "poi_longitude": "-98.2863264",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 956-283-5321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG1pF-L-nZYYRorEY6nZpIQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e21b3276-4fb6-486e-8574-53d95a84fe4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Las Quesadillas Mission / Shary Rd",
      "poi_type": "Restaurants",
      "poi_address": "205 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "Huitlacoche, quesadillas, and other Mexican favorites served with housemade tortillas in an informal space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-5e1a-73c8-ad3f-ccd2ac0b0e10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-5e1a-73c8-ad3f-ccd2ac0b0e10",
        "storage_key": "property/6737460151192623/019e1dff-5e1a-73c8-ad3f-ccd2ac0b0e10.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3518740851286804461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-quesadillas-mission--shary-rd",
      "poi_latitude": "26.201803",
      "poi_longitude": "-98.2878147",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-620-4875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-X2CXimZYYR7QebQSkU1TA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c696adfe-3ec9-4d63-a539-6a29253e2cf5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "La Fogata",
      "poi_type": "Restaurants",
      "poi_address": "300 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "Casual restaurant featuring classic Mexican eats, including goat dishes, plus live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-625c-77b7-939d-5f2a146abde2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-625c-77b7-939d-5f2a146abde2",
        "storage_key": "property/6737460151192623/019e1dff-625c-77b7-939d-5f2a146abde2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://la-fogata.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5894804669730892572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fogata",
      "poi_latitude": "26.2028534",
      "poi_longitude": "-98.2863613",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-584-8143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhcia5L-nZYYRHKufd52NzlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f3f3e2a9-dad2-4c05-b786-0efdd9e5915a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Marco's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "201 S Shary Rd Suite 630, Mission, TX 78572, USA",
      "poi_short_description": "Counter-serve chain serving up a menu of specialty or custom pizzas for takeout or delivery.",
      "poi_long_description": "Counter-serve chain serving up a menu of specialty or custom pizzas for takeout or delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-656d-70e6-99ac-1f5d6796ef35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-656d-70e6-99ac-1f5d6796ef35",
        "storage_key": "property/6737460151192623/019e1dff-656d-70e6-99ac-1f5d6796ef35.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.marcos.com/our-locations/restaurants/TX/Mission/marcos-pizza-s-shary-rd-mission-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=8156150565200152527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marcos-pizza",
      "poi_latitude": "26.1982162",
      "poi_longitude": "-98.2874182",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 956-833-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7TucgKnZYYRz0db1bl3MHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_caa7015b-e61f-4c69-b765-07d8d79bbb38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Danny's Restaurant Sharyland",
      "poi_type": "Restaurants",
      "poi_address": "2408 E Griffin Pkwy, Mission, TX 78572, USA",
      "poi_short_description": "Casual Mexican fare including tacos, enchiladas and botanas, plus breakfast options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-69c7-763c-ba44-5797343fe3f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-69c7-763c-ba44-5797343fe3f9",
        "storage_key": "property/6737460151192623/019e1dff-69c7-763c-ba44-5797343fe3f9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10608513471669078874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dannys-restaurant-sharyland",
      "poi_latitude": "26.2236107",
      "poi_longitude": "-98.2827072",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 956-580-3330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1bQH_CGnZYYRWgvI0csCOZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_de5be28d-793d-4f28-8737-44610c9d1c00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Marco's Burgers & More",
      "poi_type": "Restaurants",
      "poi_address": "2507 E Griffin Pkwy, Mission, TX 78572, USA",
      "poi_short_description": "Burgers, hot dogs, Mexican food, and other comfort eats doled out in a casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-6777-770d-a896-223f7f87e51a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-6777-770d-a896-223f7f87e51a",
        "storage_key": "property/6737460151192623/019e1dff-6777-770d-a896-223f7f87e51a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11316276909983345177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marcos-burgers--more",
      "poi_latitude": "26.2241667",
      "poi_longitude": "-98.2811111",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 956-585-2588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3VruhbOnZYYRGSqDt-R9C50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_dca17a77-d837-49c7-8776-40cb18ea492b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Mariscos El 7 Mares. El original!",
      "poi_type": "Restaurants",
      "poi_address": "2301 E Griffin Pkwy D, Mission, TX 78572, USA",
      "poi_short_description": "Family-run seafood spot for tacos, ceviche, fried fish and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-6cec-73ed-b1c2-6ed8f602ed45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-6cec-73ed-b1c2-6ed8f602ed45",
        "storage_key": "property/6737460151192623/019e1dff-6cec-73ed-b1c2-6ed8f602ed45.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11216920234837916844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mariscos-el-7-mares-el-original",
      "poi_latitude": "26.224905",
      "poi_longitude": "-98.284914",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 956-581-4234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39csCbWnZYYRrLxnF4aBqps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_5230fe4a-de85-4bdd-803f-a8832f0b3923",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Ruben Hinojosa Elementary School",
      "poi_type": "Education",
      "poi_address": "4205 Los Indios Pkwy, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rhe.sharylandisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10618090633434001906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruben-hinojosa-elementary-school",
      "poi_latitude": "26.1699109",
      "poi_longitude": "-98.2865465",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 956-584-4990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaXiuJBoIZYYR8nG8jiwJW5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_30a0d959-a125-42b6-bdea-87d0ae8e9f5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "BL Gray Junior / Middle High School",
      "poi_type": "Education",
      "poi_address": "4400 S Glasscock Rd, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-67b9-73e4-b545-5941180bf9b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-67b9-73e4-b545-5941180bf9b0",
        "storage_key": "property/6737460151192623/019e1dff-67b9-73e4-b545-5941180bf9b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://blgjh.sharylandisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3699265174439101135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bl-gray-junior--middle-high-school",
      "poi_latitude": "26.1592193",
      "poi_longitude": "-98.303411",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 956-580-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn3a3JbmnZYYRz4JqnBNuVjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_35956164-c07c-4034-8163-dc1e23b9441c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Sharyland High School",
      "poi_type": "Education",
      "poi_address": "1216 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-6d42-7489-9342-b9476ba5d3fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-6d42-7489-9342-b9476ba5d3fa",
        "storage_key": "property/6737460151192623/019e1dff-6d42-7489-9342-b9476ba5d3fa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sharylandisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2710628905187605653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharyland-high-school",
      "poi_latitude": "26.213279",
      "poi_longitude": "-98.2832429",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 956-580-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn3a3JbmnZYYRlfycs6AWniU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7cb179a3-872e-49af-bc27-ccc6b22c5e82",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Sharyland Pioneer High School",
      "poi_type": "Education",
      "poi_address": "10001 N Shary Rd, Mission, TX 78573, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-6d3b-778a-8f70-9fcffedb7b45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-6d3b-778a-8f70-9fcffedb7b45",
        "storage_key": "property/6737460151192623/019e1dff-6d3b-778a-8f70-9fcffedb7b45.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://sphs.sharylandisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12352376084653934371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharyland-pioneer-high-school",
      "poi_latitude": "26.3012574",
      "poi_longitude": "-98.2724092",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 956-271-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj4ifULalZYYRIwfUcZp0bKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_97df3264-2ae3-4d09-a22b-92f61fae493e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Harry Shimotsu Elementary",
      "poi_type": "Education",
      "poi_address": "3101 San Mateo Pkwy, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hse.sharylandisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4241264794568751932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harry-shimotsu-elementary",
      "poi_latitude": "26.165322",
      "poi_longitude": "-98.2990956",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 956-583-5643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqSzCOA4IZYYRPPujBtz_2zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_65a31e45-47dd-4d75-a2df-0cd55fe34efd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Olivero Garza Sr. Elementary",
      "poi_type": "Education",
      "poi_address": "7905 N Taylor Rd, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://oge.sharylandisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3995458833064243854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olivero-garza-sr-elementary",
      "poi_latitude": "26.2818898",
      "poi_longitude": "-98.2669389",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 956-580-5353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB0s8bkqlZYYRjrJ9y6O4cjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_730a7161-57b3-48dc-a7ab-f287fefcccd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "John H Shary Elementary",
      "poi_type": "Education",
      "poi_address": "2300 N Glasscock Rd, Mission, TX 78574, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-7056-7399-8910-2c6d7e3fc5a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-7056-7399-8910-2c6d7e3fc5a1",
        "storage_key": "property/6737460151192623/019e1dff-7056-7399-8910-2c6d7e3fc5a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jhse.sharylandisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11548332065097994170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-h-shary-elementary",
      "poi_latitude": "26.2273164",
      "poi_longitude": "-98.2904196",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 956-580-5282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgSiZqjemZYYRuk9r2NPqQ6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_dd729ca3-6db6-4be8-9274-409a42378193",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "IDEA Mission",
      "poi_type": "Education",
      "poi_address": "1600 S Schuerbach Rd, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-7369-7276-bd11-9cb73193f37f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-7369-7276-bd11-9cb73193f37f",
        "storage_key": "property/6737460151192623/019e1dff-7369-7276-bd11-9cb73193f37f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ideapublicschools.org/our-schools/idea-mission",
      "poi_directions_map_url": "https://maps.google.com/?cid=13805122108652583267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "idea-mission",
      "poi_latitude": "26.1970499",
      "poi_longitude": "-98.3656929",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 956-583-8315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIzConrCpZYYRY_kgR2qllb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8800b76f-d04d-473e-bd72-781deb2ebb51",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "University of Phoenix",
      "poi_type": "Education",
      "poi_address": "4409 N 22nd St, McAllen, TX 78504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ecampus.phoenix.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6757992949707803575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-phoenix",
      "poi_latitude": "26.2448241",
      "poi_longitude": "-98.2369584",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 956-992-9562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu0i9h8SmZYYRt4vtScg2yV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_74466450-e41b-45d4-9a2e-da30b1043087",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "South Texas College - Pecan Campus",
      "poi_type": "Education",
      "poi_address": "3201 Pecan Blvd, McAllen, TX 78501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-c6e7-773b-8bd9-ee315bca7cf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfd-c6e7-773b-8bd9-ee315bca7cf4",
        "storage_key": "property/6737460151192623/019e1dfd-c6e7-773b-8bd9-ee315bca7cf4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://campuses.southtexascollege.edu/pecan-campus.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16767401392135682517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-texas-college---pecan-campus",
      "poi_latitude": "26.2165123",
      "poi_longitude": "-98.2533831",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 956-872-8311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHzUbSgWnZYYR1TmjiLrGseg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b9a86607-711a-4c31-98c3-46c902ccc2c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Cinemark Tinseltown Mission and XD",
      "poi_type": "Entertainment",
      "poi_address": "2516 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-724c-777b-b264-90a33d3b1e03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-724c-777b-b264-90a33d3b1e03",
        "storage_key": "property/6737460151192623/019e1dff-724c-777b-b264-90a33d3b1e03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-mission/cinemark-tinseltown-mission-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5521287755027567532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-tinseltown-mission-and-xd",
      "poi_latitude": "26.1935327",
      "poi_longitude": "-98.2819499",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 956-583-1961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a631-77de-a687-616718ea8a4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a631-77de-a687-616718ea8a4b",
        "storage_key": "property/6737460151192623/019e1dff-a631-77de-a687-616718ea8a4b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJr1amGJKnZYYRrNMhzfWNn0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_8dee5203-c52a-48e8-a254-abfc27849364",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Riverside Club",
      "poi_type": "Entertainment",
      "poi_address": "E, 214 Chimney Shades, Mission, TX 78572, USA",
      "poi_short_description": "Tenderloins and burgers are some of the offerings at this boat tour agency with riverside views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-7aa0-7767-a96c-18ef2e694f18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-7aa0-7767-a96c-18ef2e694f18",
        "storage_key": "property/6737460151192623/019e1dff-7aa0-7767-a96c-18ef2e694f18.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ontheriver.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16562677858403878689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-club",
      "poi_latitude": "26.1618876",
      "poi_longitude": "-98.3325569",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 956-581-1033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ24OQa11hXIYRIQdkZ8Jz2uU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tour_agency"
    },
    {
      "id": "custom_7f7cee6e-fb26-43d0-94f7-b7c5d94b3ff1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "International Museum of Art & Science",
      "poi_type": "Entertainment",
      "poi_address": "1900 W Nolana Ave, McAllen, TX 78504, USA",
      "poi_short_description": "Modern museum featuring a range of global artwork, hands-on science exhibits & educational programs.",
      "poi_long_description": "Modern museum featuring a range of global artwork, hands-on science exhibits & educational programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-739b-711e-a856-285232b6a77e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-739b-711e-a856-285232b6a77e",
        "storage_key": "property/6737460151192623/019e1dff-739b-711e-a856-285232b6a77e.webp",
        "width": 1280,
        "height": 946
      },
      "poi_business_url": "https://theimasonline.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5967429359053022490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "international-museum-of-art--science",
      "poi_latitude": "26.2416546",
      "poi_longitude": "-98.2341678",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 956-681-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a612-7601-b195-4ac953976809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a612-7601-b195-4ac953976809",
        "storage_key": "property/6737460151192623/019e1dff-a612-7601-b195-4ac953976809.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCdLpydqmZYYRGqWXoGKR0FI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_69735ba7-1a4e-40b4-9606-7e2d502cb33a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "McAllen Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "801 Convention Center Blvd, McAllen, TX 78501, USA",
      "poi_short_description": "Vast auditorium complex with 1,800 seats & high-tech amenities for music & theatrical performances.",
      "poi_long_description": "Vast auditorium complex with 1,800 seats & high-tech amenities for music & theatrical performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-73f8-7256-b211-65407635dbe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-73f8-7256-b211-65407635dbe6",
        "storage_key": "property/6737460151192623/019e1dff-73f8-7256-b211-65407635dbe6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://experiencemcallen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7380916368008603041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcallen-performing-arts-center",
      "poi_latitude": "26.198389",
      "poi_longitude": "-98.2585525",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 956-681-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSKaSXGnZYYRoeUEuFRIbmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_73948fd5-6df7-4682-bbc2-3adbb852830f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Quinta Mazatlan",
      "poi_type": "Entertainment",
      "poi_address": "600 Sunset Dr, McAllen, TX 78503, USA",
      "poi_short_description": "Spanish-revival estate amid sprawling tropical gardens featuring over 250 species of birds.",
      "poi_long_description": "Spanish-revival estate amid sprawling tropical gardens featuring over 250 species of birds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-7c20-7599-acd0-1a15cf19c69b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-7c20-7599-acd0-1a15cf19c69b",
        "storage_key": "property/6737460151192623/019e1dff-7c20-7599-acd0-1a15cf19c69b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.quintamazatlan.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16126979140748222119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quinta-mazatlan",
      "poi_latitude": "26.176732",
      "poi_longitude": "-98.2297691",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 956-681-3370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoePYCPsJZYYRp55uiBWKzt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_dac7bd11-dc3d-4e1b-9a3d-23cf5abe929f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "5x5 Brewing Co.",
      "poi_type": "Entertainment",
      "poi_address": "801 Bryan Rd ste 174, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-8e60-72bd-a83b-996a1cda81fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-8e60-72bd-a83b-996a1cda81fe",
        "storage_key": "property/6737460151192623/019e1dff-8e60-72bd-a83b-996a1cda81fe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.5x5brewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7085917311611409867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "5x5-brewing-co",
      "poi_latitude": "26.2123369",
      "poi_longitude": "-98.3114773",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 956-445-5421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9dCCqHeoZYYRy5VjikA8VmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_97a14fe0-f95d-43fe-adf7-41bb2be22c8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Music Factory Mission",
      "poi_type": "Entertainment",
      "poi_address": "7500 W Interstate Hwy 2, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-7aff-7014-b40e-94b24345bcac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-7aff-7014-b40e-94b24345bcac",
        "storage_key": "property/6737460151192623/019e1dff-7aff-7014-b40e-94b24345bcac.webp",
        "width": 1280,
        "height": 979
      },
      "poi_business_url": "https://musicfactorymission.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8620508085944408952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "music-factory-mission",
      "poi_latitude": "26.2393166",
      "poi_longitude": "-98.409792",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 956-271-4236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYNvDgCrZYYReFsZRm4yonc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_a7f96ced-bcd8-4226-8f51-6e6f2809c3a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Cinemark Hollywood USA McAllen North",
      "poi_type": "Entertainment",
      "poi_address": "100 W Nolana Ave, McAllen, TX 78504, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-7b4d-71f9-9395-9848163b71e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-7b4d-71f9-9395-9848163b71e8",
        "storage_key": "property/6737460151192623/019e1dff-7b4d-71f9-9395-9848163b71e8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-mcallen/cinemark-hollywood-usa-mcallen-north?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMwMjktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7177000521425690865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-hollywood-usa-mcallen-north",
      "poi_latitude": "26.2395086",
      "poi_longitude": "-98.2123682",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 956-682-9438",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a631-77de-a687-616718ea8a4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a631-77de-a687-616718ea8a4b",
        "storage_key": "property/6737460151192623/019e1dff-a631-77de-a687-616718ea8a4b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJTahyxpGhZYYR8SBf6PLTmWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_7440d37e-a031-4a63-b299-ca7ed61f6678",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Mission Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "900 S Bryan Rd, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-7ec8-7265-a4f7-2979d15a3e44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-7ec8-7265-a4f7-2979d15a3e44",
        "storage_key": "property/6737460151192623/019e1dff-7ec8-7265-a4f7-2979d15a3e44.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://missionrmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10597689981388562634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-regional-medical-center",
      "poi_latitude": "26.1964064",
      "poi_longitude": "-98.3143275",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 956-323-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f2-7374-b8ba-0741d9b98053",
        "storage_key": "property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-ufsg6oZYYRyqBhnOOOEpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_4c77b5c6-8c86-47e9-83c9-2ea7da9c5d13",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Sharyland Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4101 S Shary Rd #101A, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7111265183244134947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharyland-medical-center",
      "poi_latitude": "26.160734",
      "poi_longitude": "-98.2936351",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 956-583-8889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f2-7374-b8ba-0741d9b98053",
        "storage_key": "property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2CqlxMIZYYRI6rezgFKsGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_56805fe6-ccbd-423e-84e2-37cf60cde63d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Valley Day & Night Clinic-Mission",
      "poi_type": "Health and Wellness",
      "poi_address": "305 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-80a5-70cf-badd-73c963d5c2d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-80a5-70cf-badd-73c963d5c2d8",
        "storage_key": "property/6737460151192623/019e1dff-80a5-70cf-badd-73c963d5c2d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vdnclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=234731869473940879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-day--night-clinic-mission",
      "poi_latitude": "26.2021737",
      "poi_longitude": "-98.3236865",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 956-585-7401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6t8y2yoZYYRjyV1QWTvQQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_93889d6a-acc2-4edb-9947-7024a2c7e292",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Mission Plaza Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "906 S Bryan Rd #101a, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-8120-74ce-a83d-d05d6b011ce3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-8120-74ce-a83d-d05d6b011ce3",
        "storage_key": "property/6737460151192623/019e1dff-8120-74ce-a83d-d05d6b011ce3.webp",
        "width": 799,
        "height": 449
      },
      "poi_business_url": "http://missionplazapharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12706650612350010619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-plaza-pharmacy",
      "poi_latitude": "26.1966944",
      "poi_longitude": "-98.3144826",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 956-581-8833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a63e-709b-a699-5d882ca2738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a63e-709b-a699-5d882ca2738e",
        "storage_key": "property/6737460151192623/019e1dff-a63e-709b-a699-5d882ca2738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1vOZwmoZYYR-0QfwmgXV7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_389b19c4-c1b0-4ad9-8722-7fb699b65fc4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2314 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-83bb-72fe-aaa4-50a862902525.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-83bb-72fe-aaa4-50a862902525",
        "storage_key": "property/6737460151192623/019e1dff-83bb-72fe-aaa4-50a862902525.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/mission-tx-pharmacies/2314-east-expressway-83-mission-tx-78572/storeid=7193?WT.mc_id=LS_GOOGLE_RX_7193",
      "poi_directions_map_url": "https://maps.google.com/?cid=1095688506142924793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "26.1952433",
      "poi_longitude": "-98.2889195",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-585-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a63e-709b-a699-5d882ca2738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a63e-709b-a699-5d882ca2738e",
        "storage_key": "property/6737460151192623/019e1dff-a63e-709b-a699-5d882ca2738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJfVV_OynZYYR-Z8gIeSqNA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a4dc22d8-0a52-4ad3-b61d-bac8be56f8a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2410 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-828e-70db-afcb-ea6eb8e95efb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-828e-70db-afcb-ea6eb8e95efb",
        "storage_key": "property/6737460151192623/019e1dff-828e-70db-afcb-ea6eb8e95efb.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/395-mission-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17647173459842048915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "26.193515",
      "poi_longitude": "-98.2871188",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 956-585-5783",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a63e-709b-a699-5d882ca2738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a63e-709b-a699-5d882ca2738e",
        "storage_key": "property/6737460151192623/019e1dff-a63e-709b-a699-5d882ca2738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWDuypKnZYYRkyOWU8Na5_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6026f803-93b5-418e-98e2-d8541669d192",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "HOTWORX - Mission, TX - Sharyland",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 N Shary Rd #7A, Mission, TX 78572, USA",
      "poi_short_description": "Clean, 24/7 gym featuring infrared-heated rooms for yoga and other hot workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-8446-71b8-a0e0-4366362ad639.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-8446-71b8-a0e0-4366362ad639",
        "storage_key": "property/6737460151192623/019e1dff-8446-71b8-a0e0-4366362ad639.webp",
        "width": 1280,
        "height": 991
      },
      "poi_business_url": "https://www.hotworx.net/studio/mission-tx-sharyland?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3070646835425305396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---mission-tx---sharyland",
      "poi_latitude": "26.1775789",
      "poi_longitude": "-98.2893852",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 956-679-3191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUTKduZ4JZYYRNOMzIAchnSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_ebaefe2f-d43b-444a-b012-bf36947c0bb1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "F.I.T Lab Fitness Mission",
      "poi_type": "Health and Wellness",
      "poi_address": "2015 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "Welcoming fitness center offering challenging hourlong, daily workouts, plus classes and nutritional guidance.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-8ee6-7778-9817-56d2acf1ce96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-8ee6-7778-9817-56d2acf1ce96",
        "storage_key": "property/6737460151192623/019e1dff-8ee6-7778-9817-56d2acf1ce96.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.fitlabfacilities.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16325290266284900427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-lab-fitness-mission",
      "poi_latitude": "26.2218346",
      "poi_longitude": "-98.284413",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 956-997-0076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Y7BHeCnZYYRS8ANiQAVj-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fb0d74ef-c2f6-4f74-884d-1d98aead3f5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1626 E Griffin Pkwy, Mission, TX 78572, USA",
      "poi_short_description": "Gym with 24/7 access and personal training, plus clean surroundings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-884c-7552-8281-37a1e9e6bd16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-884c-7552-8281-37a1e9e6bd16",
        "storage_key": "property/6737460151192623/019e1dff-884c-7552-8281-37a1e9e6bd16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/mission-texas-5026/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=5026",
      "poi_directions_map_url": "https://maps.google.com/?cid=14740144413180582072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "26.2258797",
      "poi_longitude": "-98.2985299",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 956-600-8944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoehfMoqnZYYRuFiWRT-Dj8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1df1d5d5-c4dd-4129-8f7f-8391c696bed2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Bannworth Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bannworth Park Pavilion, 1822 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "In addition to a jogging trail & athletic fields, this low-key park offers a small pond & pier.",
      "poi_long_description": "In addition to a jogging trail & athletic fields, this low-key park offers a small pond & pier.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-8a77-71ca-a4e1-1b78b0cf5b05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-8a77-71ca-a4e1-1b78b0cf5b05",
        "storage_key": "property/6737460151192623/019e1dff-8a77-71ca-a4e1-1b78b0cf5b05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4541001151161688458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bannworth-park",
      "poi_latitude": "26.2175351",
      "poi_longitude": "-98.2835627",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 956-580-8650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f5-751b-999a-c15da2d84a3c",
        "storage_key": "property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2_TfPrenZYYRiuGh23zgBD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_78e7e3c2-a75a-43a3-aa16-463d51fc0028",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Bentsen Palm Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1801 S Inspiration Rd, Mission, TX 78572, USA",
      "poi_short_description": "Pet-friendly outdoor space featuring basketball courts, a playground and baseball diamonds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-88ec-7726-92bc-2cface15b3ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-88ec-7726-92bc-2cface15b3ed",
        "storage_key": "property/6737460151192623/019e1dff-88ec-7726-92bc-2cface15b3ed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://missiontexas.us/city-departments/parks-and-recreation/city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17839991593467140792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentsen-palm-community-park",
      "poi_latitude": "26.1982497",
      "poi_longitude": "-98.3591463",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 956-580-8760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f5-751b-999a-c15da2d84a3c",
        "storage_key": "property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt8tek8mpZYYRuFqQfNVhlPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_65c90298-2701-4815-83e3-61b6df0d5097",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Bentsen-Rio Grande Valley State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5JM9+GM4, 2800 S Bentsen Palm Dr, Mission, TX 78572, USA",
      "poi_short_description": "Popular birding destination with a viewing tower, bird blinds, trails & a bilingual exhibit hall.",
      "poi_long_description": "Popular birding destination with a viewing tower, bird blinds, trails & a bilingual exhibit hall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-e1e0-7159-950c-eb8decb07505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfd-e1e0-7159-950c-eb8decb07505",
        "storage_key": "property/6737460151192623/019e1dfd-e1e0-7159-950c-eb8decb07505.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/bentsen-rio-grande-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=4261951861198311716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentsen-rio-grande-valley-state-park",
      "poi_latitude": "26.185498",
      "poi_longitude": "-98.3794443",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 956-584-9156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f5-751b-999a-c15da2d84a3c",
        "storage_key": "property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cwRy1kHZYYRJFGKEKN-JTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_c9d85a87-ac30-4c7c-8b7b-1efe4363c545",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "National Butterfly Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3333 Butterfly Pk Dr, Mission, TX 78572, USA",
      "poi_short_description": "More than 200 species of wild butterflies in a 100-acre habitat with trails, gardens & a pavilion.",
      "poi_long_description": "More than 200 species of wild butterflies in a 100-acre habitat with trails, gardens & a pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-89bd-77b0-908a-5710ea71680b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-89bd-77b0-908a-5710ea71680b",
        "storage_key": "property/6737460151192623/019e1dff-89bd-77b0-908a-5710ea71680b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nationalbutterflycenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5729683575126862861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-butterfly-center",
      "poi_latitude": "26.179835",
      "poi_longitude": "-98.3664926",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 956-583-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f5-751b-999a-c15da2d84a3c",
        "storage_key": "property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-S6W-9ipZYYRDazTutrsg08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_728b4325-5816-474a-b419-49e464337e74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Anzalduas Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6400 Anzalduas Dam Rd, Mission, TX 78572, USA",
      "poi_short_description": "A natural 96-acre grassland park on the river known for its rich birdlife.",
      "poi_long_description": "A natural 96-acre grassland park on the river known for its rich birdlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-e4c5-741d-b025-04b3a2181c12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfd-e4c5-741d-b025-04b3a2181c12",
        "storage_key": "property/6737460151192623/019e1dfd-e4c5-741d-b025-04b3a2181c12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hidalgocounty.us/280/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15805713243786363408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anzalduas-park",
      "poi_latitude": "26.1407848",
      "poi_longitude": "-98.3282428",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 956-585-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f5-751b-999a-c15da2d84a3c",
        "storage_key": "property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_x-hTMgHZYYREMKS9XMsWds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3558188c-054d-4af8-b42f-3f479fd98ff9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "City Of Mission Hike and Bike Trail Park Entrance",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1801 Native Land Design, Mission, TX 78572, USA",
      "poi_short_description": "Well-maintained park for hiking and bike trails including a 2-mile paved route.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-93ea-77ba-bae8-bcbc52550aca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-93ea-77ba-bae8-bcbc52550aca",
        "storage_key": "property/6737460151192623/019e1dff-93ea-77ba-bae8-bcbc52550aca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10561204286636687055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-mission-hike-and-bike-trail-park-entrance",
      "poi_latitude": "26.1924055",
      "poi_longitude": "-98.3302696",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f5-751b-999a-c15da2d84a3c",
        "storage_key": "property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLQq30xeoZYYRz_5P0VfvkJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9219393c-9f54-41e8-b476-e0ff47302a2b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Estero Llano Grande State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3301 S International Blvd FM 1015, Weslaco, TX 78596, USA",
      "poi_short_description": "230-acre wetlands space attracting many birds, including endangered & colorful coastal species.",
      "poi_long_description": "230-acre wetlands space attracting many birds, including endangered & colorful coastal species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-8f4a-721d-b645-84ea54629780.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-8f4a-721d-b645-84ea54629780",
        "storage_key": "property/6737460151192623/019e1dff-8f4a-721d-b645-84ea54629780.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tpwd.texas.gov/state-parks/estero-llano-grande",
      "poi_directions_map_url": "https://maps.google.com/?cid=4589157395450640189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "estero-llano-grande-state-park",
      "poi_latitude": "26.1271024",
      "poi_longitude": "-97.9580927",
      "poi_miles_from_property": "25.7",
      "poi_walking_minutes": "9 hours 20 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 956-565-3919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f5-751b-999a-c15da2d84a3c",
        "storage_key": "property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZyveoQJ4ZYYRPTcxNlb2rz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_cfa125bd-e3df-43f8-9576-680d2762e44b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Valley Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "301 S Border Ave, Weslaco, TX 78596, USA",
      "poi_short_description": "Nature preserve with trails for walking, wildlife, and birding, plus a public restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-9009-720b-8ceb-5e944f96b7e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-9009-720b-8ceb-5e944f96b7e4",
        "storage_key": "property/6737460151192623/019e1dff-9009-720b-8ceb-5e944f96b7e4.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.valleynaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4557037236240889134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-nature-center",
      "poi_latitude": "26.159153",
      "poi_longitude": "-97.997198",
      "poi_miles_from_property": "21.4",
      "poi_walking_minutes": "7 hours 48 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 956-969-2475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f5-751b-999a-c15da2d84a3c",
        "storage_key": "property/6737460151192623/019e1dfd-f3f5-751b-999a-c15da2d84a3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9b73yq13ZYYRLrVd3jjZPT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_df7f2af7-3104-460f-bd0c-819cab7f178f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "McAllen International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2500 S Bicentennial Blvd, McAllen, TX 78503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-eaa0-750f-8f35-7b6b24974b49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfd-eaa0-750f-8f35-7b6b24974b49",
        "storage_key": "property/6737460151192623/019e1dfd-eaa0-750f-8f35-7b6b24974b49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mcallenairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17674746782101345214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcallen-international-airport",
      "poi_latitude": "26.1770587",
      "poi_longitude": "-98.2391389",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 956-681-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3a6-716b-8a26-836dbcf379d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3a6-716b-8a26-836dbcf379d0",
        "storage_key": "property/6737460151192623/019e1dfd-f3a6-716b-8a26-836dbcf379d0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6ej8OEJZYYRvhMhso1QSfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f215fcbf-f6ec-45d3-97e0-fe279120a7e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1501 US-83 BUS, McAllen, TX 78501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-97e1-74e0-9cc0-aa2cdfc3aefd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-97e1-74e0-9cc0-aa2cdfc3aefd",
        "storage_key": "property/6737460151192623/019e1dff-97e1-74e0-9cc0-aa2cdfc3aefd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/bus/mcallen-tx/mcallen-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=928542173943620544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "26.2045023",
      "poi_longitude": "-98.2364269",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6kgY012ZYYRwOPgBDDY4gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_429c9ec9-6c15-41ac-b738-8e221e822436",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "La Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "2200 S 10th St, McAllen, TX 78503, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-bde7-7213-9ddb-dfd30338cdc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfd-bde7-7213-9ddb-dfd30338cdc7",
        "storage_key": "property/6737460151192623/019e1dfd-bde7-7213-9ddb-dfd30338cdc7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/la-plaza-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=3293283645024331875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-plaza",
      "poi_latitude": "26.1863534",
      "poi_longitude": "-98.2361963",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 956-687-5251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f39c-7659-ad50-6f0ba17b1d2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f39c-7659-ad50-6f0ba17b1d2d",
        "storage_key": "property/6737460151192623/019e1dfd-f39c-7659-ad50-6f0ba17b1d2d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqWCH3FinZYYRY2hHzgYYtC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_19c26212-1643-4212-a0db-450158345b40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Valley Metro Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "510 S Pleasantview Dr, Weslaco, TX 78596, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-9800-712c-b036-8156c2796ee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-9800-712c-b036-8156c2796ee1",
        "storage_key": "property/6737460151192623/019e1dff-9800-712c-b036-8156c2796ee1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11874701882167951180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-metro-transit-center",
      "poi_latitude": "26.1561867",
      "poi_longitude": "-97.9669172",
      "poi_miles_from_property": "23.4",
      "poi_walking_minutes": "8 hours 30 mins",
      "poi_biking_minutes": "2 hours 17 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 800-574-8322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8X1cmIN3ZYYRTH9IbHJqy6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_43e55493-d774-42c4-8945-6e09ef2a0dc7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Edinburg Transit Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "519 W University Dr, Edinburg, TX 78539, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4451582637785693982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edinburg-transit-terminal",
      "poi_latitude": "26.3026624",
      "poi_longitude": "-98.1681565",
      "poi_miles_from_property": "16.7",
      "poi_walking_minutes": "6 hours 8 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6",
        "storage_key": "property/6737460151192623/019e1dfd-f3f7-75eb-b9ee-3e6bd6a065c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBTGUOkejZYYRHj-D1dIyxz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_aea294ce-57e6-463f-bb42-77e02b7615c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Motel 6 Mission, TX",
      "poi_type": "Transportation & Transit",
      "poi_address": "1813 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "Straightforward budget property with an outdoor pool, plus free Wi-Fi, parking & morning coffee.",
      "poi_long_description": "Straightforward budget property with an outdoor pool, plus free Wi-Fi, parking & morning coffee.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-97ca-7629-9d9a-d35ea32960ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-97ca-7629-9d9a-d35ea32960ec",
        "storage_key": "property/6737460151192623/019e1dff-97ca-7629-9d9a-d35ea32960ec.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.motel6.com/property/motel-mission-texas-us-293308?lid=Local_Milestone&travelAgentNumber=TA001305&corporatePlusNumber=CP792N5W&utm_source=google%20my%20business&utm_medium=organic%20listing&utm_campaign=visit%20website&utm_content=global",
      "poi_directions_map_url": "https://maps.google.com/?cid=869556202131975598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "motel-6-mission-tx",
      "poi_latitude": "26.197964",
      "poi_longitude": "-98.2986066",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 956-201-4076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a636-727a-8752-2eed57292aee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dff-a636-727a-8752-2eed57292aee",
        "storage_key": "property/6737460151192623/019e1dff-a636-727a-8752-2eed57292aee.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ9240BeanZYYRrm1QPMJIEQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "motel"
    },
    {
      "id": "custom_0b0dfc13-eb4f-44bc-acc6-5cbc447ce907",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Sharyland School District Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1106 N Shary Rd, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.sharylandisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1387088503055181176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharyland-school-district-administration",
      "poi_latitude": "26.2120398",
      "poi_longitude": "-98.2851582",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 956-580-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-SPJormnZYYReOWh-KTtPxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e8e32b0d-8878-499b-9038-07efb1c46bec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Mission CISD",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 Bryce Dr, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-9852-7665-b89a-07e1347838b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-9852-7665-b89a-07e1347838b5",
        "storage_key": "property/6737460151192623/019e1dff-9852-7665-b89a-07e1347838b5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.mcisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8419700437533209931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-cisd",
      "poi_latitude": "26.2178201",
      "poi_longitude": "-98.3102156",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 956-323-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlaZ883ioZYYRSzVePvDI2HQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac89cfc0-ff91-4950-84df-5a7dad54320b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Mission City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 E 8th St, Mission, TX 78572, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-9ae4-7617-9c86-89c2a949296f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-9ae4-7617-9c86-89c2a949296f",
        "storage_key": "property/6737460151192623/019e1dff-9ae4-7617-9c86-89c2a949296f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://missiontexas.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12711701469206441271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-city-hall",
      "poi_latitude": "26.2123127",
      "poi_longitude": "-98.3129711",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 956-580-8650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f6-72e0-86f4-48beebf16348.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f6-72e0-86f4-48beebf16348",
        "storage_key": "property/6737460151192623/019e1dfd-f3f6-72e0-86f4-48beebf16348.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_VBbFneoZYYRN23cAiMJabA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_d71b6db7-69df-47a3-aac8-bcc6edf00f83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "DHR Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5501 S McColl Rd, Edinburg, TX 78539, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-9a15-7354-97b7-d8fea33b731d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-9a15-7354-97b7-d8fea33b731d",
        "storage_key": "property/6737460151192623/019e1dff-9a15-7354-97b7-d8fea33b731d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.dhrhealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11652355383802862139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dhr-health",
      "poi_latitude": "26.252433",
      "poi_longitude": "-98.205071",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 956-362-8677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f2-7374-b8ba-0741d9b98053",
        "storage_key": "property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4xy1jihZYYROxouGHx7taE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_97f0d13a-0db2-4d6f-9226-2f59f8681705",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "The University of Texas Rio Grande Valley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 W University Dr, Edinburg, TX 78539, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-9dd5-7208-8d9b-31083fafd5a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-9dd5-7208-8d9b-31083fafd5a1",
        "storage_key": "property/6737460151192623/019e1dff-9dd5-7208-8d9b-31083fafd5a1.webp",
        "width": 1280,
        "height": 695
      },
      "poi_business_url": "https://www.utrgv.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3232489350524170508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-rio-grande-valley",
      "poi_latitude": "26.3081983",
      "poi_longitude": "-98.1740158",
      "poi_miles_from_property": "16.6",
      "poi_walking_minutes": "6 hours 6 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 956-882-4026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f408-7467-a702-b504256a2e59",
        "storage_key": "property/6737460151192623/019e1dfd-f408-7467-a702-b504256a2e59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTYynFUuiZYYRDPE5FvAb3Cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_18156f53-59e1-4f3c-a659-89572afac0bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "South Texas Health System Edinburg",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1102 W Trenton Rd, Edinburg, TX 78539, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-9cdc-756a-96bb-fef1aa87b559.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-9cdc-756a-96bb-fef1aa87b559",
        "storage_key": "property/6737460151192623/019e1dff-9cdc-756a-96bb-fef1aa87b559.webp",
        "width": 1133,
        "height": 637
      },
      "poi_business_url": "https://www.southtexashealthsystemedinburg.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16930180172763095965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-texas-health-system-edinburg",
      "poi_latitude": "26.2614185",
      "poi_longitude": "-98.1819532",
      "poi_miles_from_property": "13.2",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 956-388-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f2-7374-b8ba-0741d9b98053",
        "storage_key": "property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP6MdFXShZYYRnePnzCoV9Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_df6cb4b3-c91a-4dfd-b6e7-02b5299c3b38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "South Texas Health System McAllen",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 W Expy 83, McAllen, TX 78503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-e11a-7398-8847-e2be8e9bcb88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dfd-e11a-7398-8847-e2be8e9bcb88",
        "storage_key": "property/6737460151192623/019e1dfd-e11a-7398-8847-e2be8e9bcb88.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://southtexashealthsystemmcallen.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=13194540889675734681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-texas-health-system-mcallen",
      "poi_latitude": "26.186761",
      "poi_longitude": "-98.2256802",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 956-632-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f2-7374-b8ba-0741d9b98053",
        "storage_key": "property/6737460151192623/019e1dfd-f3f2-7374-b8ba-0741d9b98053.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbMqzFWnZYYRmR59DwhtHLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_96157363-da82-4593-a566-fd7d65ac0567",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Hidalgo County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 N Closner Blvd, Edinburg, TX 78539, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dff-a01d-7529-88ca-23fd3a098bd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dff-a01d-7529-88ca-23fd3a098bd2",
        "storage_key": "property/6737460151192623/019e1dff-a01d-7529-88ca-23fd3a098bd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hidalgocounty.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8843651487350406597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hidalgo-county-courthouse",
      "poi_latitude": "26.3017031",
      "poi_longitude": "-98.1629487",
      "poi_miles_from_property": "16.6",
      "poi_walking_minutes": "6 hours 9 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 956-292-7090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f6-72e0-86f4-48beebf16348.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f6-72e0-86f4-48beebf16348",
        "storage_key": "property/6737460151192623/019e1dfd-f3f6-72e0-86f4-48beebf16348.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRdibeCgJZYYRxT3gDCz2uno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_41aff198-b2e3-4448-857a-b618edd42008",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2427 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of products, including personal care items. They highlight the clean and organized store, and the efficient online order pickup service. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019ea8f4-0d76-74d5-aee1-ac29e5074e05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8f4-0d76-74d5-aee1-ac29e5074e05",
        "storage_key": "property/6737460151192623/019ea8f4-0d76-74d5-aee1-ac29e5074e05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/mission/2237",
      "poi_directions_map_url": "https://maps.google.com/?cid=5197185253975037293&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "26.1977831",
      "poi_longitude": "-98.283014",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 956-928-7280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f39c-7659-ad50-6f0ba17b1d2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f39c-7659-ad50-6f0ba17b1d2d",
        "storage_key": "property/6737460151192623/019e1dfd-f39c-7659-ad50-6f0ba17b1d2d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeUAHG5OnZYYRbZUU33McIEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_15d7d05f-b43a-4344-b7c1-c4cede7b7f8f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "2409 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, and bakery items, as well as a large selection of wines and specialty sauces. They highlight the reasonable prices and the clean, organized layout of the store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019ea8f4-0d69-742a-905a-d615489fa83f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8f4-0d69-742a-905a-d615489fa83f",
        "storage_key": "property/6737460151192623/019ea8f4-0d69-742a-905a-d615489fa83f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/mission/mission-h-e-b-plus--94?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=277004236145853327&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "26.198027",
      "poi_longitude": "-98.285746",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 956-205-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f39a-775c-9cfa-098ebad66b7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f39a-775c-9cfa-098ebad66b7f",
        "storage_key": "property/6737460151192623/019e1dfd-f39a-775c-9cfa-098ebad66b7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdj-D1CnZYYRj4PAmOId2AM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fa18a513-844e-4343-bda0-9819dd651d0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2410 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "Chain department store carrying groceries, apparel, and furniture, plus electronics and home goods.",
      "poi_long_description": "People say this department store offers a wide variety of products and has sufficient stock of different and basic items. They also highlight the reasonable prices, discounts, and fast service.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019ea8f4-107d-77ae-9435-428eda84c093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8f4-107d-77ae-9435-428eda84c093",
        "storage_key": "property/6737460151192623/019ea8f4-107d-77ae-9435-428eda84c093.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/395-mission-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17311430652489719279&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "26.193861",
      "poi_longitude": "-98.2869949",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 956-580-3393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f39c-7659-ad50-6f0ba17b1d2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f39c-7659-ad50-6f0ba17b1d2d",
        "storage_key": "property/6737460151192623/019e1dfd-f39c-7659-ad50-6f0ba17b1d2d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsWDuypKnZYYR7111Y3WOPvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a64175c5-6901-4af4-b6a4-b5ec1a260449",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "100% Antojitos Mexicanos",
      "poi_type": "Restaurants",
      "poi_address": "2306 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "Tacos, burritos & chalupas round out the menu at this straightforward strip-mall Mexican restaurant.",
      "poi_long_description": "People say this restaurant offers the best Mexican food in the valley. Others mention it's a great place to go when unsure what to order.\n\nSome reviews mention the food can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019ea8f4-0c89-7749-8516-ca9471f506fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8f4-0c89-7749-8516-ca9471f506fa",
        "storage_key": "property/6737460151192623/019ea8f4-0c89-7749-8516-ca9471f506fa.webp",
        "width": 528,
        "height": 400
      },
      "poi_business_url": "https://100antojitosmexicanosusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10251136846845972317&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "100-antojitos-mexicanos",
      "poi_latitude": "26.1952915",
      "poi_longitude": "-98.2907449",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 956-581-7879",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrT4BTuynZYYRXQ8sPKZaQ44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_e1e51008-aa1c-4e18-8765-55e84f3316e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Kumori Sushi & Teppanyaki Palms Crossing",
      "poi_type": "Restaurants",
      "poi_address": "3300 W Expy 83 Ste 145, McAllen, TX 78501, USA",
      "poi_short_description": "Local Japanese chain serving sushi, teppanyaki & cocktails in a contemporary setting.",
      "poi_long_description": "Diners like this restaurant's delicious and fresh sushi, teriyaki chicken, and a wide variety of rolls, with many highlighting the flavorful options and beautiful presentation. They also mention the welcoming and peaceful atmosphere, along with the recent remodeling that provides a sleek and modern upgrade. Guests consistently praise the staff for being attentive, friendly, and providing excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019ea8f4-133f-705d-a0f1-a2025e6402a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8f4-133f-705d-a0f1-a2025e6402a2",
        "storage_key": "property/6737460151192623/019ea8f4-133f-705d-a0f1-a2025e6402a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kumorisushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11662139690130356668&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kumori-sushi--teppanyaki-palms-crossing",
      "poi_latitude": "26.197435",
      "poi_longitude": "-98.25914",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 956-630-5551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bTq5HCnZYYRvDk0b0I-2KE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_8ed48af4-c987-4857-9f70-06e3a4b8e1d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "2419 E Expressway 83, Mission, TX 78572, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Diners say this restaurant serves up delicious three-for-me deals, bacon ranch quesadillas, creamy Cajun pasta, and chips with refreshing salsa. They also highlight the friendly staff and fast service.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019ea8f4-0d22-7315-8d5c-9e0597eb63fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8f4-0d22-7315-8d5c-9e0597eb63fc",
        "storage_key": "property/6737460151192623/019ea8f4-0d22-7315-8d5c-9e0597eb63fc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations/us/texas/mission/sharyland?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=15435435479149832922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "26.196261",
      "poi_longitude": "-98.28518400000002",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 956-585-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUzjywapZYYR2uovsMmuNdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_75992edb-f019-475c-bbe3-c50f01810920",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "Crumbl",
      "poi_type": "Restaurants",
      "poi_address": "2505 E Expressway 83 Ste 400, Mission, TX 78572, USA",
      "poi_short_description": "Baked from scratch, specialty cookies with unique flavors rotate weekly.",
      "poi_long_description": "People say this cookie shop offers delicious, soft, and warm cookies with a great variety of rotating flavors. They also highlight the fast and efficient service, noting orders are often ready in minutes. Visitors appreciate the clean store and the friendly, welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019ea8f4-115a-7697-bb7e-33f2cd7dec6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8f4-115a-7697-bb7e-33f2cd7dec6c",
        "storage_key": "property/6737460151192623/019ea8f4-115a-7697-bb7e-33f2cd7dec6c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://crumblcookies.com/stores/tx/txmission?utm_source=google+business&utm_medium=profile&utm_campaign=CRUMBL-US+%7C+GOOGLE+BUSINESS+%7C+STORE+PAGE+%7C+ONGOING+%7C+CONSIDERATION+%7C+PROFILE",
      "poi_directions_map_url": "https://maps.google.com/?cid=16191993880744641285&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crumbl",
      "poi_latitude": "26.1972115",
      "poi_longitude": "-98.282388",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 956-997-5260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f395-77ce-bf1d-acb80e67bbc4",
        "storage_key": "property/6737460151192623/019e1dfd-f395-77ce-bf1d-acb80e67bbc4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ9MPqVenZYYRBUMVS6WEteA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_46f6b1fc-789c-44e4-8f39-22f140e69faa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "poi_name": "U.S. Customs and Border Protection - Anzalduas Port of Entry",
      "poi_type": "Transportation & Transit",
      "poi_address": "6100 S Stewart Rd, Mission, TX 78572, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019ea8f4-0d51-706e-8385-268b16f021d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8f4-0d51-706e-8385-268b16f021d4",
        "storage_key": "property/6737460151192623/019ea8f4-0d51-706e-8385-268b16f021d4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cbp.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10321484404650841551&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "us-customs-and-border-protection---anzalduas-port-of-entry",
      "poi_latitude": "26.145519",
      "poi_longitude": "-98.3121329",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 956-205-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-f3f6-72e0-86f4-48beebf16348.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dfd-f3f6-72e0-86f4-48beebf16348",
        "storage_key": "property/6737460151192623/019e1dfd-f3f6-72e0-86f4-48beebf16348.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aX5stkHZYYRz5XyZWFHPY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a8b4afea-2296-46bf-8940-caf6d3a8eac3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8fc5f689-57a1-4f45-a099-06082cd2a888",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_05de2597-2919-4fdb-8a1a-07f25b1aa39e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2e5e00bc-27fd-4cdc-a85a-447c2f3405a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b4616ad7-666b-470e-abac-63b93e5de588",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_37419a65-4602-4804-9c1e-86a00ee42226",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d728f9f1-b004-4f10-bbea-0a119c9a4480",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "rating": "5",
      "name": "Marco Ortiz",
      "text": "Great customer service Amanda and Sara are the best always take care of me when doing deliveries to their tenants",
      "date": "2026-05-08",
      "title": "false"
    },
    {
      "id": "custom_d7845931-92f3-4b4b-98a8-9bd800789078",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "rating": "5",
      "name": "Nate",
      "text": "My mom has been living here for close to a year and she loves it. It’s make me consider move here lol\n\nRuben from maintenance has been super helpful. He even helped me get my wallet from the trash can after it was accidentally thrown out.",
      "date": "2026-05-08",
      "title": "false"
    },
    {
      "id": "custom_f2f53fa3-58b2-4ca8-aceb-5b35cf08c3ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "rating": "5",
      "name": "Camila Salinas",
      "text": "Great experience Dulce was so helpful I appreciate it so much she explained in detail everything I needed to know.",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_8450cec5-e882-4646-bb63-596d7e6beb74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "rating": "5",
      "name": "Gina Aguilar",
      "text": "Thank you for such a nice time today!\nDelicios mini pancakes, and got to meet wonderful neighbors from the community.\nThanks for all the hard work you always do!\nGinna Aguilar\n#1427😊",
      "date": "2026-04-17",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_27ea34fe-569d-4d44-8b28-5331183402de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019e1dfd-a38f-76b9-b600-af272c545cbe.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dfd-a38f-76b9-b600-af272c545cbe",
        "storage_key": "property/6737460151192623/019e1dfd-a38f-76b9-b600-af272c545cbe.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6674cf20794979371b5f5265"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e8d-1d8f-766e-ae0d-22012a4cc561",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-the-plantation-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623"
    },
    {
      "lead_collector_id": "01996472-ccce-7204-ba29-2814edce8521",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-the-plantation-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623"
    },
    {
      "lead_collector_id": "019d6352-172e-775c-ad28-2ed355249e92",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "page_item_url": "pool-apartments-mission-tx",
      "search_query": "pool apartments in Mission TX",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Mission, TX",
      "h2_subtitle": "Discover pool apartments in Mission, TX for ultimate relaxation. Enjoy our sparkling pool and stunning views at Plantation Apartments.",
      "page_copy": "Welcome to Plantation Apartments, the perfect choice for those seeking pool apartments in Mission, TX. Our community offers a refreshing swimming pool, ideal for relaxing or enjoying a sunny day. Whether you prefer a one, two, or three-bedroom home, our diverse floor plans are sure to meet your needs.\n\nLocated in the heart of Mission, Plantation Apartments not only provides a serene poolside experience but also features luxurious amenities such as a modern clubhouse, business center, and controlled access for peace of mind. Schedule a visit today and discover why our pool apartments are the ideal fit for your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
      "featured_image_media": {
        "alt_text": "The Plantation apartment complex monument sign with landscaping.",
        "public_id": "019d0784-623e-7629-a279-263d39d4f812",
        "storage_key": "property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Mission, TX",
      "seo_description": "Find your new home at Plantation Apartments with a pool in Mission, TX. Enjoy modern amenities and stunning views today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "page_item_url": "mission-tx-apartments-in-unit-laundry",
      "search_query": "Mission TX apartments with in-unit laundry",
      "category": "Amenity",
      "h1_title": "Mission, TX Apartments with In-Unit Laundry",
      "h2_subtitle": "Explore Mission, TX apartments featuring in-unit laundry convenience. Enjoy modern amenities at Plantation Apartments.",
      "page_copy": "At Plantation Apartments in Mission, TX, we understand the importance of convenience. That's why our select units are equipped with in-unit laundry facilities, making everyday chores effortless and freeing up more time for relaxation. Choose from our variety of one, two, and three-bedroom floor plans tailored to fit your lifestyle.\n\nBeyond the comfort of in-unit laundry, Plantation Apartments offers an array of top-tier amenities, including a refreshing pool, a well-equipped business center, and controlled access for your peace of mind. Embrace modern living with the added luxury of doing laundry from the comfort of your own apartment, and discover why our community is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
      "featured_image_media": {
        "alt_text": "The Plantation apartment complex monument sign with landscaping.",
        "public_id": "019d0784-623e-7629-a279-263d39d4f812",
        "storage_key": "property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mission, TX Apartments with In-Unit Laundry",
      "seo_description": "Discover Plantation Apartments in Mission, TX with in-unit laundry. Experience modern living with top amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-hidalgo-county",
      "search_query": "air conditioned apartments Hidalgo County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Hidalgo County",
      "h2_subtitle": "Experience comfort in air-conditioned apartments in Hidalgo County. Discover Plantation Apartments in Mission, TX.",
      "page_copy": "Beat the Texas heat by choosing Plantation Apartments, offering air-conditioned apartments in the heart of Hidalgo County. Our community in Mission, TX ensures residents enjoy optimal comfort, regardless of the weather outside, with state-of-the-art air conditioning systems in each unit.\n\nIn addition to a comfortable living environment, Plantation Apartments provides residents with first-class amenities such as a refreshing pool, a modern business center, and inviting hardwood floors. Our diverse selection of one, two, and three-bedroom layouts ensures you'll find the home that perfectly suits your needs. Explore our community today and discover why Plantation Apartments is the ultimate choice for air-conditioned comfort in Hidalgo County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
      "featured_image_media": {
        "alt_text": "The Plantation apartment complex monument sign with landscaping.",
        "public_id": "019d0784-623e-7629-a279-263d39d4f812",
        "storage_key": "property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Hidalgo County",
      "seo_description": "Find comfort at Plantation Apartments in Hidalgo County. Enjoy air-conditioned living and premium amenities in Mission, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "page_item_url": "gated-community-apartments-mission",
      "search_query": "gated community apartments Mission",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Mission",
      "h2_subtitle": "Explore gated community apartments in Mission, TX. Plantation Apartments offers a secure and welcoming environment.",
      "page_copy": "Discover Plantation Apartments, a premier gated community in Mission, TX, where security and serenity are top priorities. Our apartments offer not only the privacy of a gated entrance but also a sense of community and peace of mind. Choose from our selection of one, two, and three-bedroom homes designed to meet diverse living needs.\n\nResidents of Plantation Apartments enjoy access to a range of exceptional amenities, including a refreshing swimming pool, an on-site clubhouse for social gatherings, and convenient controlled access for enhanced security. Experience the benefits of gated community living in Mission and make Plantation Apartments your new home, where safety and comfort blend seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
      "featured_image_media": {
        "alt_text": "The Plantation apartment complex monument sign with landscaping.",
        "public_id": "019d0784-623e-7629-a279-263d39d4f812",
        "storage_key": "property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in Mission",
      "seo_description": "Discover Plantation Apartments, a gated community in Mission, TX, offering secure living with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "page_item_url": "mission-tx-fitness-center-apartments",
      "search_query": "Mission TX fitness center apartments",
      "category": "Amenity",
      "h1_title": "Mission, TX Fitness Center Apartments",
      "h2_subtitle": "Find Mission, TX apartments with a fitness center. Enjoy active living at Plantation Apartments.",
      "page_copy": "Plantation Apartments in Mission, TX offers more than just a place to live; it provides a lifestyle centered around health and well-being. With our on-site fitness center, you can maintain an active routine without leaving the comfort of your community. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, perfect for any lifestyle.\n\nIn addition to the fitness center, Plantation Apartments boasts a suite of outstanding amenities, including a business center for work-from-home days, a beautiful pool for relaxation, and wheelchair-accessible rooms. Our vibrant community in Mission, TX is ideal for those seeking both comfort and convenience. Experience a dynamic and healthy lifestyle at Plantation Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
      "featured_image_media": {
        "alt_text": "The Plantation apartment complex monument sign with landscaping.",
        "public_id": "019d0784-623e-7629-a279-263d39d4f812",
        "storage_key": "property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mission, TX Fitness Center Apartments",
      "seo_description": "Experience active living at Plantation Apartments, Mission, TX. Enjoy our on-site fitness center and premium amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mission-tx",
      "search_query": "one bedroom apartments Mission TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Mission, TX",
      "h2_subtitle": "Explore ideal one bedroom apartments in Mission, TX at Plantation Apartments. Perfect living spaces with modern amenities await you.",
      "page_copy": "Searching for the perfect one-bedroom apartment in Mission, TX? Look no further than Plantation Apartments, where comfort meets convenience. Our well-designed one-bedroom layouts are ideal for singles or couples seeking a cozy, functional, and stylish home.\n\nAt Plantation Apartments, residents are treated to a variety of amenities, including a refreshing pool, business center, and hardwood floors that enhance the living experience. Situated in the vibrant city of Mission, TX, our community offers controlled access for added security and a welcoming environment. Discover the joys of living in a one-bedroom oasis at Plantation Apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
      "featured_image_media": {
        "alt_text": "The Plantation apartment complex monument sign with landscaping.",
        "public_id": "019d0784-623e-7629-a279-263d39d4f812",
        "storage_key": "property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Mission, TX",
      "seo_description": "Discover comfortable one-bedroom apartments in Mission, TX at Plantation Apartments, featuring modern amenities and ideal living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-hidalgo-county",
      "search_query": "two bedroom apartments near Hidalgo County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Hidalgo County",
      "h2_subtitle": "Find spacious two bedroom apartments near Hidalgo County at Plantation Apartments, located in Mission, TX, offering modern amenities and comfort.",
      "page_copy": "Discover the perfect blend of comfort and convenience with our two-bedroom apartments near Hidalgo County. Located in the desirable Mission, TX area, Plantation Apartments offers the lifestyle you desire with spacious floor plans ideal for families or roommates.\n\nOur community features a wealth of amenities such as a scenic pool, a fully equipped business center, and balconies with breathtaking views. Each apartment is designed with functionality and elegance in mind, including hardwood floors and modern finishes. With controlled access and wheelchair accessibility, we ensure a secure and comfortable environment. Explore the vibrant area of Mission, TX and make Plantation Apartments your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
      "featured_image_media": {
        "alt_text": "The Plantation apartment complex monument sign with landscaping.",
        "public_id": "019d0784-623e-7629-a279-263d39d4f812",
        "storage_key": "property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Hidalgo County",
      "seo_description": "Spacious two-bedroom apartments near Hidalgo County are available at Plantation Apartments in Mission, TX. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192623",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-in-78572",
      "search_query": "three bedroom apartments in 78572",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 78572",
      "h2_subtitle": "Discover spacious three bedroom apartments in the 78572 area at Plantation Apartments. Perfect for families or roommates, offering comfort and modern amenities.",
      "page_copy": "For those seeking ample living space in the 78572 area, the three-bedroom apartments at Plantation Apartments are a perfect choice. Located in the vibrant city of Mission, TX, our community caters to families and roommates alike, providing a comfortable and modern living experience.\n\nResidents of our three-bedroom apartments enjoy a host of amenities including a sparkling pool, a community clubhouse, and a business center. Each apartment is equipped with hardwood floors and a private balcony to enhance your living experience. With controlled access and wheelchair-accessible rooms, Plantation Apartments ensures a secure and accommodating environment just for you. Experience the spacious and inviting atmosphere of our three-bedroom homes today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
      "featured_image_media": {
        "alt_text": "The Plantation apartment complex monument sign with landscaping.",
        "public_id": "019d0784-623e-7629-a279-263d39d4f812",
        "storage_key": "property/6737460151192623/019d0784-623e-7629-a279-263d39d4f812.webp",
        "width": 1240,
        "height": 825
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 78572",
      "seo_description": "Explore three-bedroom apartments in the 78572 area at Plantation Apartments, offering spacious living with modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3399"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483246"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4687860"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WX7P3WN8"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "956-300-2615"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "956-300-2740"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "956-300-3684"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "956-300-2710"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "956-420-7730"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "956-300-3704"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "956-300-2729"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "956-300-2760"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "956-300-3910"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "956-300-3855"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "956-277-9310"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "956-405-7868"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "956-300-3858"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "956-593-1877"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "956-253-1218"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "956-363-4719"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "956-790-0797"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "956-983-9742"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "956-474-3539"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17320214186"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "956-300-2715"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "956-269-9682"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "0a2160011ee12d88"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "956-276-8859"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "956-300-2778"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "956-300-2787"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "956-300-1768"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "956-300-2779"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "956-300-2736"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "956-300-2582"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.theplantationmission.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192623/019e84c7-7e7b-72dd-96ea-695bfd089edd.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "956-300-2713"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "956-277-9310"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3399",
  "custom_repli_id": "5028483246",
  "custom_realpage_id": "4687860",
  "custom_knock_a_link": "https://www.theplantationmission.com?utm_knock=a",
  "custom_knock_g_link": "https://www.theplantationmission.com?utm_knock=g",
  "custom_knock_r_link": "https://www.theplantationmission.com?utm_knock=r",
  "custom_knock_w_link": "https://www.theplantationmission.com?utm_knock=w",
  "custom_knock_z_link": "https://www.theplantationmission.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-WX7P3WN8",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.theplantationmission.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.theplantationmission.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.theplantationmission.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.theplantationmission.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.theplantationmission.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.theplantationmission.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "956-300-2615",
  "custom_knock_ads_link": "https://www.theplantationmission.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.theplantationmission.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "956-300-2740",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.theplantationmission.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.theplantationmission.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.theplantationmission.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.theplantationmission.com?utm_knock=psa",
  "custom_knock_r_number": "956-300-3684",
  "custom_knock_w_number": "956-300-2710",
  "custom_knock_z_number": "956-420-7730",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "956-300-3704",
  "custom_knock_amap_link": "https://www.theplantationmission.com?utm_knock=amap",
  "custom_knock_ar_number": "956-300-2729",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "956-300-2760",
  "custom_knock_fb_number": "956-300-3910",
  "custom_knock_fl_number": "956-300-3855",
  "custom_knock_gp_number": "956-277-9310",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.theplantationmission.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "956-405-7868",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.theplantationmission.com?utm_knock=bcard",
  "custom_knock_bnr_number": "956-300-3858",
  "custom_knock_cfres_link": "https://www.theplantationmission.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "956-593-1877",
  "custom_knock_lgp_number": "956-253-1218",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.theplantationmission.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "956-363-4719",
  "custom_knock_psa_number": "956-790-0797",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "956-983-9742",
  "custom_knock_bandit_link": "https://www.theplantationmission.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.theplantationmission.com?utm_knock=flyers",
  "custom_knock_osoc_number": "956-474-3539",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17320214186",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "956-300-2715",
  "custom_knock_cfres_number": "956-269-9682",
  "custom_knock_chatgpt_link": "https://www.theplantationmission.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "0a2160011ee12d88",
  "custom_knock_dirmail_link": "https://www.theplantationmission.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "956-276-8859",
  "custom_knock_propbro_link": "https://www.theplantationmission.com?utm_knock=propbro",
  "custom_knock_bandit_number": "956-300-2778",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "956-300-2787",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.theplantationmission.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "956-300-1768",
  "custom_knock_dirmail_number": "956-300-2779",
  "custom_knock_propbro_number": "956-300-2736",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "956-300-2582",
  "custom_knock_maintenance_link": "https://www.theplantationmission.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192623/019e84c7-7e7b-72dd-96ea-695bfd089edd.mp4",
  "custom_knock_maintenance_number": "956-300-2713",
  "custom_ppc_tracking_phone_number": "956-277-9310"
};

export const generatedAt = '2026-10-07T17:14:18.302Z';
